import { Component, NgZone, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { WithSearchBarAndSieve } from '../../../helpers/base-classes/withSearcBarAndSieve.class';
import { PhaseContract } from '../../../models/request-and-responses/rest-api/enums/phaseContract.enum';
import { IFormContractResponse } from '../../../models/request-and-responses/rest-api/interfaces/formContractResponse';
import { IShadowGenericAnagraphic } from '../../../models/request-and-responses/rest-api/interfaces/shadowGenericAnagraphic';
import {
    NgbDate,
    NgbDateStruct,
    NgbModal,
    NgbModalConfig,
    NgbModalOptions,
    NgbModalRef,
    NgbTimeStruct
} from '@ng-bootstrap/ng-bootstrap';
import {
    Attachment,
    ContractAttachments,
    IContractAttachment,
    IContractAttachmentNotMapped
} from '../../../helpers/attachmentsMeta.class';
import { ToastrService } from 'ngx-toastr';
import { DataService } from '../../../services/data.service';
import { NotificationService } from '../../../services/notification.service';
import { ContentTypeSupported, DownloadType, FileDownloadService } from '../../../services/file-download.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AutocompleteService } from '../../../services/autocomplete.service';
import {
    ISieveFilterObject,
    SieveOperator,
    SieveSortOrder,
    SieveString
} from '../../../helpers/sieve/sieveString.class';
import { CatalogType } from '../../../models/request-and-responses/rest-api/enums/catalogType.enum';
import { IShadowSitePodCatalogs } from '../../../models/request-and-responses/rest-api/interfaces/shadowSitePodCatalogs';
import { IShadowSitePdrCatalogs } from '../../../models/request-and-responses/rest-api/interfaces/shadowSitePdrCatalogs';
import { Phase } from '../../../helpers/contractPhase.class';
import { ContractPermission } from '../../../models/request-and-responses/rest-api/enums/contractPermission';
import { PataviumRole } from '../../../models/request-and-responses/rest-api/enums/role.enum.model';
import { TypeContract } from '../../../models/request-and-responses/rest-api/enums/typeContract.enum';
import { IShadowUser } from '../../../models/request-and-responses/rest-api/interfaces/shadowUser';
import { AnagraphicType } from '../../../models/request-and-responses/rest-api/enums/anagraphicType.enum';
import { UtilsDateService } from '../../../helpers/utils-date.service';
import { UtilsStringService } from '../../../helpers/utils-string.service';
import { EnergyOrGasContract } from '../../../models/request-and-responses/rest-api/enums/energyOrGasContract.enum';
import { ICityResponse } from '../../../models/request-and-responses/rest-api/interfaces/cityResponse';
import { City, ICity } from '../../../helpers/city.class';
import { ISupplierResponse } from '../../../models/request-and-responses/rest-api/interfaces/supplierResponse';
import { Supplier } from '../../../helpers/supplier.class';
import { TypeRequest } from '../../../models/request-and-responses/rest-api/enums/typeRequest.enum';
import { BillingPeriod } from '../../../models/request-and-responses/rest-api/enums/billingPeriod';
import { IVendorResponse } from '../../../models/request-and-responses/rest-api/interfaces/distributorResponse';
import { Vendor } from '../../../helpers/vendor.class';
import { ICatalog } from '../../../models/request-and-responses/rest-api/interfaces/catalog';
import { IPhaseObject, PhaseObject, PhaseObjects } from '../../../helpers/phaseObjects';
import { Subscription } from 'rxjs/Subscription';
import { PdrTypeObjects } from '../../../helpers/pdrTypeObjects';
import { FiscalUsageTypeObjects } from '../../../helpers/FiscalUsageTypeObjects';
import { WithdrawalClassObjects } from '../../../helpers/withdrawalClassObjects';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import {
    catchError,
    debounceTime,
    delay,
    distinctUntilChanged,
    filter,
    finalize,
    map,
    skip,
    switchMap,
    switchMapTo,
    takeUntil,
    tap
} from 'rxjs/operators';
import { of } from 'rxjs/internal/observable/of';
import { PodTensionObjects } from '../../../helpers/podTensionObjects';
import { TypeTensionLink } from '../../../models/request-and-responses/rest-api/enums/typeTensionLink.enum';
import { GlobalsService } from '../../../services/globals.service';
import { PodTypeObjects } from '../../../helpers/podTypeObjects';
import { PodType } from '../../../models/request-and-responses/rest-api/enums/podType.enum';
import { BrandObjects, IBrandObject } from '../../../helpers/brandObjects';
import { LocalStorageService } from '../../../services/local-storage.service';
import 'rxjs-compat/add/observable/interval';
import { TypeExportContract } from '../../../models/request-and-responses/rest-api/enums/typeExportContract';
import { SessionStorageService } from '../../../services/session-storage.service';
import { BrandType } from '../../../models/request-and-responses/rest-api/enums/brandType';
import { CustomerVisibilityType } from '../../../models/request-and-responses/rest-api/enums/customerVisibility';
import { HttpErrorResponse } from '@angular/common/http';
import { EMPTY, iif, interval, merge, NEVER } from 'rxjs';
import { LockedEntityType } from '../../../models/request-and-responses/rest-api/enums/lockedEntity.enum';
import { SieveFilter, SieveSort } from '../../../helpers/sieve/sieve-filters-and-sorts';
import { MarketTypes } from '../../../helpers/marketTypes';
import { OnCallPeriods } from '../../../helpers/onCallPeriods';
import { ClientTitles } from '../../../helpers/clientTitles';
import { SupplyType } from '../../../models/request-and-responses/rest-api/enums/SupplyType';
import { TaskExportRequestSettings } from '../../../models/request-and-responses/rest-api/classes/taskExportRequestSettings';
import { FormContractRequest } from '../../../models/request-and-responses/rest-api/classes/formContractRequest';
import { TableContractModel } from '../../../models/request-and-responses/rest-api/classes/tableContractModel';
import { FormContractResponse } from '../../../models/request-and-responses/rest-api/classes/formContractResponse';
import { ShadowGenericAnagraphic } from '../../../models/request-and-responses/rest-api/classes/shadowGenericAnagraphic';
import { ShadowSitePdrCatalogs } from '../../../models/request-and-responses/rest-api/classes/shadowSitePdrCatalogs';
import { ShadowSitePodCatalogs } from '../../../models/request-and-responses/rest-api/classes/shadowSitePodCatalogs';
import { FileWithAttachRequest } from '../../../models/request-and-responses/rest-api/classes/fileWithAttachRequest';
import { ShadowCustomerCreate } from '../../../models/request-and-responses/rest-api/classes/shadowCustomerCreate';
import { ShadowRepresentativeCreate } from '../../../models/request-and-responses/rest-api/classes/shadowRepresentativeCreate';
import { IVeryShortCatalog } from '../../../models/request-and-responses/rest-api/interfaces/veryShortCatalog';
import { IVeryShortUser } from '../../../models/request-and-responses/rest-api/interfaces/veryShortUser';
import { ICreateLockRequest } from '../../../models/request-and-responses/rest-api/interfaces/createLockRequest';
import { IPageConfig } from '../../../models/frontend/page-config';
import { LocalStorageKey } from '../../../models/frontend/local-storage.key';
import { WebSocketMessageService } from '../../../services/web-socket/web-socket-message.service';
import { UserSessionInfo } from '../../../models/frontend/user.session-info';
import { ContractStateChangeMessage } from '../../../helpers/socket-messages/contract-state-change-message';
import { ShadowUser } from '../../../models/request-and-responses/rest-api/classes/shadowUser';
import { TDateTimeFormat, TDateTimePicker } from '../../../components/datetime-picker/datetime-picker.component';
import { ContractPhaseFilters } from '../../../helpers/contractPhaseFilters.class';
import { IPataviumPagedResponse } from '../../../helpers/response.class';
import { RespectPatternDirective } from '../../../directives/respectPattern.directive';
import { IValueLabel } from '../../../models/frontend/generic-value-label.interface';
import { AttachType } from '../../../models/request-and-responses/rest-api/enums/attachType';
import { IFormContractRequest } from '../../../models/request-and-responses/rest-api/interfaces/formContractRequest';
import { ITaskExportResponse } from '../../../models/request-and-responses/rest-api/interfaces/taskExportResponse';
import { ITimestampInfos, TimestampInfos } from '../../../models/request-and-responses/rest-api/classes/timestampInfos';
import { InternalEventsService } from '../../../services/internal-events.service';
import { ITableContractModel } from '../../../models/request-and-responses/rest-api/interfaces/tableContractModel';
import { AskForConfirmationComponent } from '../../../components/ask-for-confirmation/ask-for-confirmation.component';
import { ContractService } from '../../../services/resources/contract.service';
import { ICustomerAuditRequest, ICustomerAuditResponse } from '../../../models/request-and-responses/rest-api/interfaces/customerAudit';
import { Color } from '../../../helpers/color.enum';

enum TechnicalDataType {
    Pod = 'POD',
    Pdr = 'PDR'
}

enum ModalMode {
    Delete = 'DELETE',
    Info = 'INFO',
    Edit = 'MODIFY',
    Create = 'CREATE',
    ChangePhase = 'CHANGEPHASE',
    ExportCSV = 'EXPORTCVS'
}

enum ExportType {
    Simple = 0,
    Energy = 1,
    Gas = 2,
    Teleselling = 3, // not used anymore
    PhoneCall = 4
}

enum PreviousModalForConflict {
    Edit = 0,
    ChangePhase = 1
}

interface IPodCodeStatus {
    podCode: string;
    status: boolean;
}
interface IPdrCodeStatus {
    pdrCode: string;
    status: boolean;
}

interface IFileAndDate {
    file: File;
    date: Date;
}

interface IConditions {
    info: boolean;
    edit: boolean;
    create: boolean;
    changePhase: boolean;
}

interface IVocalOrder {
    contractId: number;
    listened: boolean;
}

class VisibilityConditions implements IConditions {
    info: boolean;
    edit: boolean;
    create: boolean;
    changePhase: boolean;
    private _defaultValue = false;
    constructor(conditions?: IConditions, defaultvalue: boolean = false) {
        if (defaultvalue != null) {
            this._defaultValue = defaultvalue;
        }
        if (conditions != null) {
            this.info = this.getBool(conditions.info);
            this.edit = this.getBool(conditions.edit);
            this.create = this.getBool(conditions.create);
            this.changePhase = this.getBool(conditions.changePhase);
        }
    }
    getConditionOnModalMode(modalMode: ModalMode) {
        switch (modalMode) {
            case ModalMode.Info:
                return this.info;
            case ModalMode.Edit:
                return this.edit;
            case ModalMode.Create:
                return this.create;
            case ModalMode.ChangePhase:
                return this.changePhase;
            default:
                return false;
        }
    }

    private getBool(val: boolean): boolean {
        return val != null ? val : this._defaultValue;
    }
}

enum ModalDismissReason {
    Exit
}

interface IRrs<Req, Resp> {
    request: Req;
    response: Resp;
    success: boolean;
}

@Component({
    selector: 'app-contract',
    templateUrl: './contract.component.html',
    styleUrls: ['./contract.component.css']
})
export class ContractComponent extends WithSearchBarAndSieve implements OnInit, OnDestroy {
    @ViewChild('solveConflict') templateSolveConflict: TemplateRef<any>;
    @ViewChild('specificContract') templateSpecificContract: TemplateRef<any>;
    @ViewChild('changePhase') templateChangePhase: TemplateRef<any>;
    @ViewChild('lockConflict') templateLockConflict: TemplateRef<any>;

    /*ENUMS and COSTANTS*/
    DEBOUNCE_TIME = 100;
    ContractPermission = ContractPermission;
    PhaseContract = PhaseContract;
    TechnicalDataType = TechnicalDataType;
    AttachType = AttachType;
    TypeContract = TypeContract;
    AnagraphicType = AnagraphicType;
    DownloadType = DownloadType;
    PodTensionObjects = PodTensionObjects;
    Role = PataviumRole;
    BillingPeriod = BillingPeriod;
    EnergyOrGasContract = EnergyOrGasContract;
    TypeRequest = TypeRequest;
    ExportType = ExportType;
    PdrTypeObjects = PdrTypeObjects;
    FiscalUsageTypeObjects = FiscalUsageTypeObjects;
    WithdrawalClassObjects = WithdrawalClassObjects;
    PodTypeObjects = PodTypeObjects;
    readonly DefaultVAT = 22.0;
    readonly DefaultDomesticVAT = 10.0;
    readonly DefaultMonthsDuration = 12;
    SessionStorageService = SessionStorageService;
    SieveSort = SieveSort;

    private messagesSubscription_ContractStateChange: Subscription;

    // table
    contracts: TableContractModel[];
    contractSubscription: Subscription;

    //phase filters
    phaseFilters: ContractPhaseFilters;
    showPhases = false;
    phaseFiltersHaveChanged = false;
    // modal
    modalRef: NgbModalRef;
    modalMode: ModalMode;
    contract: IFormContractRequest;
    pod: IShadowSitePodCatalogs;
    pdr: IShadowSitePdrCatalogs;
    contractAttachments: ContractAttachments;
    isEditable: boolean;
    isDeletable: boolean;
    isVirgin: boolean;
    tecnicalDataIndex: number; // index of pdr/pod array
    brands: IBrandObject[];
    // arrays for modal
    availablePhases: Phase[];
    podCodeStatusList: IPodCodeStatus[] = [];
    pdrCodeStatusList: IPdrCodeStatus[] = [];
    isAValidTecnicalDataCode: boolean;
    podCode: string;
    pdrCode: string;
    remiCode: string;

    //vatExemptionCodes
    vatExemptionCodes: string[] = [];
    isDownloadingVatExemptions = false;
    isWaitingExport = false;

    //client cities
    clientCities: Observable<ICity[]>;
    isLoadingClientCities = false;
    clientCity: ICity;
    clientCitySubject = new Subject<string>();
    //recapiti cities
    recapitiCities: Observable<ICity[]>;
    isLoadingRecapitiCity = false;
    recapitiCity: ICity;
    recapitiCitySubject = new Subject<string>();
    //tecnicalData cities
    tecnicalDataCities: Observable<ICity[]>;
    isLoadingTecnicalDataCity = false;
    tecnicalDataCity: ICity;
    tecnicalDataCitySubject = new Subject<string>();
    //signature cities
    signatureCities: Observable<ICity[]>;
    isLoadingSignatureCity = false;
    signatureCitySubject = new Subject<string>();
    //supplier
    suppliers: Observable<ISupplierResponse[]>;
    isLoadingPreviousSupplier = false;
    previousSupplier: ISupplierResponse;
    supplierSubject = new Subject<string>();
    //vendor
    vendors: Observable<IVendorResponse[]>;
    vendorsSubject = new Subject<string>();
    previousVendor: IVendorResponse;
    isLoadingPreviousVendor = false;
    //client
    clients: Observable<IShadowGenericAnagraphic[]>;
    clientsSubject = new Subject<string>();
    client: IShadowGenericAnagraphic;
    isLoadingClients = false;
    ricercaClientePerCodiceFiscaleOId: boolean = false;
    //referral (PORTAUNAMICO)
    referrals: Observable<IShadowGenericAnagraphic[]>;
    referralSubject = new Subject<string>();
    referral: IShadowGenericAnagraphic;
    isLoadingReferrals = false;
    ricercaReferralPerCodiceFiscaleOId: boolean = false;
    //agent to assign contract to
    him: IShadowUser; //load a contract for the user "him"
    agents: Observable<IVeryShortUser[]>;
    agentsSubject = new Subject<string>();
    isLoadingAgents = false;
    //pricelists Energy
    pricelists: Observable<IVeryShortCatalog[]>;
    pricelist: IVeryShortCatalog;
    isLoadingPricelists = false;
    pricelistsSubject = new Subject<string>();
    private _previousModal: PreviousModalForConflict = null;

    // flags for modal
    attachTypeUploading: AttachType = null; // used for activate fa-refresh
    tecnicalDataType: TechnicalDataType = null;
    isANewCustomer: boolean = null;
    isTechnicalDataPanelOpened = false;
    isRecapitiEditable: boolean;
    wantToEditClient: boolean;
    isSettingHim: boolean = false;
    isInitFinished = true;
    csvStartDate: Date;
    csvEndDate: Date;
    exportToBeSend = false;
    exportTaskDelay = 1500;
    isSavingContract = false;
    public contractEditBackup: FormContractResponse;
    typeExport: ExportType = ExportType.Simple;
    private contractLockSubscription: Subscription;
    private lockId: number;
    private backupModalMode: ModalMode;
    private lockTemplateRef: TemplateRef<any>;
    @ViewChild('fileAndDateTemplate') fileAndDateTemplate: TemplateRef<any>;
    fileAndDateTemplateModalRef: NgbModalRef;
    @ViewChild('confirmAttachTypeTemplate') confirmAttachTypeTemplate: TemplateRef<any>;
    confirmAttachTypeTemplateModalRef: NgbModalRef;
    contractCustomFilter = SieveFilter.Contract.Contract;
    MarketTypes = MarketTypes;
    OnCallPeriodList = OnCallPeriods.list;
    ClientTitles = ClientTitles;
    choosableAttachmentsList: IValueLabel<AttachType, string>[] = [
        { value: AttachType.CartaIdentita, label: 'Carta di identità' },
        { value: AttachType.CartaIdentitaElettronica, label: 'Carta di identità elettronica' }
    ];
    private isLoadingSupplyOffers: boolean = false;
    private supplyOffers: number[];
    private sessionInfo: UserSessionInfo;
    private readonly BUFFER_TIME_SPAN: number = 90 * 1000;
    private readonly MAX_BUFFER_SIZE: number = 100;
    private readonly BUFFER_LENGTH_POLLING_PERIOD: number = 30 * 1000;
    private messagesSubscription_ContractStateChange_list: ContractStateChangeMessage[];
    private messagesSubscription_timeSignal: Observable<boolean>;
    private messagesSubscription_ContractStateChange_lengthSignal: Observable<boolean>;
    private contractRefreshDataSignalSubscription: Subscription;
    private audioAdesioneContrattualeHasBeenListenedTo: boolean;
    private audioAdesioneContrattualeNeedToBeListenedTo: boolean;
    private vocalOrdersListened: IVocalOrder[] = [];
    private updateDataEventSubscription: Subscription;
    // change phase
    phase: Phase;
    phaseToChangeTo: PhaseContract;
    private askForConfirmationRef: NgbModalRef;
    //delega
    public hasDelega: boolean;

    // aggiunta note
    noteOriginali: string;
    noteAggiunte: string;

    // chiamata benvenuto
    public canDoChiamataBenvenuto: boolean;
    public chiamataBenvenutoDate: NgbDate;
    public chiamataBenvenutoFrom: NgbTimeStruct;
    public chiamataBenvenutoTo: NgbTimeStruct;

    // PORTAUNAMICO
    public canDoPortaUnAmico: boolean;


    // searchbox
    public searchbox: string = null;
    public searchprop: string = null;
    public searchval: string = null;

    public prescreeningLoader = false;

    constructor(
        private toastr: ToastrService,
        private dataService: DataService,
        private modalService: NgbModal,
        private modalConfig: NgbModalConfig,
        private zone: NgZone,
        private notification: NotificationService,
        private fileDownloadService: FileDownloadService,
        protected ngxService: NgxUiLoaderService,
        protected ptautocomplete: AutocompleteService,
        public utilsDate: UtilsDateService,
        protected utilsString: UtilsStringService,
        protected globals: GlobalsService,
        protected localStorageService: LocalStorageService,
        protected webSocketMessageService: WebSocketMessageService,
        private internalEventsService: InternalEventsService,
        private contractService: ContractService
    ) {
        super([], [], ptautocomplete, ngxService, localStorageService);
        this.localStorageKey = LocalStorageKey.ContractPageConfig;
        this.sessionInfo = SessionStorageService.sessionInfo;
        this.initMessagesSubscriptions();
        this.initUpdateDataEventSubscription();
        this.loadConfiguration();
        this.contractSubscription = new Subscription();
    }

    static podIsNew(pod: IShadowSitePodCatalogs): boolean {
        return pod.id == null;
    }

    static pdrIsNew(pdr: IShadowSitePdrCatalogs): boolean {
        return pdr.id == null;
    }

    static pdrIsEditable(pdr: IShadowSitePdrCatalogs) {
        return pdr.isEditable === true;
    }

    static podIsEditable(pod: IShadowSitePodCatalogs): boolean {
        return pod.isEditable === true;
    }

    private static offerNeedValidation(
        supplyOfferResponsible: number,
        supplyOfferSize: number,
        priceList: IVeryShortCatalog
    ) {
        const thereIsAnOffer = priceList != null && priceList.supplyOfferFamily != null;
        const notValidatedYet = supplyOfferSize != null && supplyOfferResponsible == null;
        return thereIsAnOffer && notValidatedYet;
    }

    private initUpdateDataEventSubscription(): void {
        this.updateDataEventSubscription = this.internalEventsService.EVENTS.UPDATE_DATA.CONTRACTS.UPDATE_REQUESTED
            .observable
            .pipe(tap(e => {
                console.debug(`Triggered event ${e.description}: updating data`);
                this.initData();
            }))
            .subscribe();
    }

    private initMessagesSubscriptions() {
        //init variables
        this.messagesSubscription_ContractStateChange_list = [];
        this.messagesSubscription_timeSignal = interval(this.BUFFER_TIME_SPAN).pipe(
            switchMapTo(of(true))
        );
        this.messagesSubscription_ContractStateChange_lengthSignal = interval(
            this.BUFFER_LENGTH_POLLING_PERIOD
        ).pipe(
            switchMapTo(
                iif(
                    () =>
                        this.messagesSubscription_ContractStateChange_list.length >=
                        this.MAX_BUFFER_SIZE,
                    of(true),
                    of(false)
                )
            )
        );
        // ContractStateChange subscription
        this.messagesSubscription_ContractStateChange = this.webSocketMessageService
            .EVENTS
            .CONTRACT_STATE_CHANGE
            .observable
            .pipe(
                tap(list => {
                    console.info(`Received contract state changes`, list);
                    this.messagesSubscription_ContractStateChange_list.push(list.message);
                }),
                catchError(err => {
                    console.error(err);
                    return EMPTY;
                }),
                finalize(() => {
                    console.warn(`Unsubscribing ContractStateChange observable`);
                    if (this.messagesSubscription_ContractStateChange) {
                        this.messagesSubscription_ContractStateChange.unsubscribe();
                    }
                })
            )
            .subscribe();

        //merge signals
        const time_condition = (e: boolean) =>
            e === true && this.messagesSubscription_ContractStateChange_list.length > 0;
        const length_condition = (e: boolean) =>
            e === true && this.messagesSubscription_ContractStateChange_list.length >= this.MAX_BUFFER_SIZE;
        this.contractRefreshDataSignalSubscription = merge(
            this.messagesSubscription_timeSignal,
            this.messagesSubscription_ContractStateChange_lengthSignal
        )
            .pipe(
                filter(e => length_condition(e) || time_condition(e)),
                debounceTime(this.BUFFER_LENGTH_POLLING_PERIOD / 2),
                tap(() => {
                    console.log(`The refresh signal will result in initData method call`);
                    this.zone.runTask(() => this.initData());
                }),
                tap(() => (this.messagesSubscription_ContractStateChange_list = [])),
                catchError(err => {
                    console.error(err);
                    return EMPTY;
                }),
                finalize(() => {
                    console.warn(`Unsubscribing refreshDataSignalSubscription`);
                    if (this.contractRefreshDataSignalSubscription) {
                        this.contractRefreshDataSignalSubscription.unsubscribe();
                    }
                })
            )
            .subscribe();
    }

    ngOnInit() {
        super.ngOnInit(); // from BaseComponent
        this.initData();
    }

    ngOnDestroy(): void {
        console.log(`ngOnDestroy contract`);
        if (this.messagesSubscription_ContractStateChange) {
            this.messagesSubscription_ContractStateChange.unsubscribe();
        }
        if (this.contractRefreshDataSignalSubscription) {
            this.contractRefreshDataSignalSubscription.unsubscribe();
        }
        if (this.updateDataEventSubscription) {
            this.updateDataEventSubscription.unsubscribe();
        }
    }

    customFilterConfiguration(pageConfig: IPageConfig): IPageConfig {
        if (pageConfig) {
            pageConfig.filters = this.phaseFilters.activeFilters;
        }
        return pageConfig;
    }

    protected loadConfiguration(): IPageConfig {
        const pageConfig = super.loadConfiguration();
        if (pageConfig) {
            this._initPhaseFilters(pageConfig.filters);
        }
        return pageConfig;
    }

    // GET DATA
    private async _getContract(id: number): Promise<IFormContractResponse> {
        let _contract: IFormContractResponse = null;
        await this.contractService
            .getContract(id)
            .toPromise()
            .then(value => {
                _contract = value.item;
                console.log(`got contract`, _contract);
            })
            .catch(console.error);
        return _contract;
    }

    async downloadVatExemptionsCodes(): Promise<void> {
        this.isDownloadingVatExemptions = true;
        this.vatExemptionCodes = await new Promise<string[]>(executor => {
            this.dataService.getVatExemptions().subscribe(response => {
                executor(response.payload.map(ve => ve.id));
            });
        });
        this.isDownloadingVatExemptions = false;
    }

    // SETTER
    //set cities
    setClientCity(city: ICity) {
        this.clientCity = city;
        this.contract.client.istatCodeCity = city.codIstatCity;
        this.contract.client.city = city.name;
        this.contract.client.province = city.province;
        this.contract.client.shortProvince = city.shortProvince;
    }
    setRecapitiCity(city: ICity) {
        this.recapitiCity = city;
        this.contract.contract.istatCodeCity = city.codIstatCity;
        this.contract.contract.city = city.name;
        this.contract.contract.province = city.province;
        this.contract.contract.shortProvince = city.shortProvince;
    }
    setPodCity(city: ICity) {
        if (city != null) {
            this.tecnicalDataCity = city;
            this.pod.istatCodeCity = city.codIstatCity;
            this.pod.city = city.name;
            this.pod.province = city.province;
            this.pod.shortProvince = city.shortProvince;
        }
    }
    setPdrCity(city: ICity) {
        if (city != null) {
            this.tecnicalDataCity = city;
            this.pdr.istatCodeCity = city.codIstatCity;
            this.pdr.city = city.name;
            this.pdr.province = city.province;
            this.pdr.shortProvince = city.shortProvince;
        }
    }
    //set previous suppliers
    setPodPreviousSupplier(supp: ISupplierResponse) {
        this.pod.previousSupplier = supp.name;
        this.pod.codEnerpPreviousSupplier = supp.idCode;
    }
    setPdrPreviousSupplier(supp: ISupplierResponse) {
        this.pdr.previousSupplier = supp.name;
        this.pdr.codEnerpPreviousSupplier = supp.idCode;
    }

    //set previous vendors
    setPodPreviousVendor(vendor: IVendorResponse) {
        this.previousVendor = vendor;
        this.pod.previousVendor = vendor.name;
        this.pod.codEnerpVendor = vendor.idCode;
    }
    setPdrPreviousVendor(vendor: IVendorResponse) {
        this.previousVendor = vendor;
        this.pdr.previousVendor = vendor.name;
        this.pdr.codEnerpVendor = vendor.idCode;
    }
    //client
    setContractClient(client: IShadowGenericAnagraphic) {
        if (client != null) {
            this.client = client;
            this.contract.client = client;
            //set city
            const clientCity = new City({
                codIstatCity: client.istatCodeCity,
                idProvince: null,
                name: client.city,
                postalCode: client.postalCode,
                province: client.province,
                shortProvince: client.shortProvince
            });
            this.setClientCity(clientCity);
            //copy recapiti
            this.copyRecapiti();
        }
    }
    //referral
    setCustomerReferral(referral: IShadowGenericAnagraphic) {
        if (referral != null) {
            this.referral = referral;
            //this.contract.client.referral = referral.id;
        }
    }

    //pricelists
    setPodCatalog(catalog: IVeryShortCatalog) {
        this.pricelist = catalog;
        this.pod.idCatalog = catalog.id;
        this.pod.isGenerali = catalog.isGenerali;
        this.pod.supplyOfferSize = null;
        this.cleanPodOfferValidation();
        if (this.pricelist != null) {
            this.loadSupplyOffer(this.pricelist.supplyOfferFamily, EnergyOrGasContract.Energy);
        }
    }

    setPdrCatalog(catalog: IVeryShortCatalog) {
        this.pricelist = catalog;
        this.pdr.idCatalog = catalog.id;
        this.pdr.isGenerali = catalog.isGenerali;
        this.pdr.supplyOfferSize = null;
        this.cleanPdrOfferValidation();
        if (this.pricelist != null) {
            this.loadSupplyOffer(this.pricelist.supplyOfferFamily, EnergyOrGasContract.Gas);
        }
    }

    setAgent(agent: IVeryShortUser): void {
        const id = agent != null ? agent.id : null;
        if (id == null) {
            this.toastr.error(`Impossibile selezionare il venditore`);
            return;
        }
        this.setHim(id);
    }

    private setHim(id: number): void {
        this.isSettingHim = true;
        iif(
            () => id === this.sessionInfo.userId,
            this.dataService.whoAmI(),
            this.dataService.getUser(id)
        )
            .pipe(
                tap(response => {
                    this.him = response.item.user;
                    this.canDoPortaUnAmico = this.him.canDoPortaUnAmico;
                }),
                catchError(err => {
                    console.error(err);
                    this.toastr.error(`Errore durante la selezione del venditore`);
                    this.him = null;
                    return EMPTY;
                }),
                finalize(() => {
                    this.isSettingHim = false;
                })
            )
            .subscribe();
    }

    //TYPEAHEAD
    //cities
    private _getCitiesObservable(userInput: string): Observable<ICity[]> {
        if (userInput == null) {
            userInput = 'a';
        }
        return this.dataService.getLikeNameCity(userInput).pipe(map(response => response.payload));
    }

    private _initClientCitiesObservable() {
        this.clientCities = this.clientCitySubject.pipe(
            debounceTime(this.DEBOUNCE_TIME),
            distinctUntilChanged(),
            tap(() => (this.isLoadingClientCities = true)),
            switchMap(term => {
                console.log(`SEARCH CLIENT CITY '${term}'`);
                return this._getCitiesObservable(term).pipe(
                    takeUntil(this.clientCitySubject.pipe(skip(1))),
                    catchError(() => of([])),
                    tap(() => (this.isLoadingClientCities = false))
                );
            })
        );
    }
    private _initRecapitiCitiesObservable() {
        this.recapitiCities = this.recapitiCitySubject.pipe(
            debounceTime(this.DEBOUNCE_TIME),
            distinctUntilChanged(),
            tap(() => (this.isLoadingRecapitiCity = true)),
            switchMap(term => {
                console.log(`SEARCH RECAPITI CITY '${term}'`);
                return this._getCitiesObservable(term).pipe(
                    takeUntil(this.recapitiCitySubject.pipe(skip(1))),
                    catchError(() => of([])),
                    tap(() => (this.isLoadingRecapitiCity = false))
                );
            })
        );
    }
    private _initTechnicalDataCitiesObservable() {
        this.tecnicalDataCities = this.tecnicalDataCitySubject.pipe(
            debounceTime(this.DEBOUNCE_TIME),
            distinctUntilChanged(),
            tap(() => (this.isLoadingTecnicalDataCity = true)),
            switchMap(term => {
                console.log(`SEARCH TECNICAL DATA CITY '${term}'`);
                return this._getCitiesObservable(term).pipe(
                    takeUntil(this.tecnicalDataCitySubject.pipe(skip(1))),
                    catchError(() => of([])),
                    tap(() => (this.isLoadingTecnicalDataCity = false))
                );
            })
        );
    }
    private _initSignatureCitiesObservable() {
        this.signatureCities = this.signatureCitySubject.pipe(
            debounceTime(this.DEBOUNCE_TIME),
            distinctUntilChanged(),
            tap(() => (this.isLoadingSignatureCity = true)),
            switchMap(term => {
                console.log(`SEARCH SIGNATURE CITY '${term}'`);
                return this._getCitiesObservable(term).pipe(
                    takeUntil(this.signatureCities.pipe(skip(1))),
                    catchError(() => of([])),
                    tap(() => (this.isLoadingSignatureCity = false))
                );
            })
        );
    }

    //suppliers
    private _getSuppliersObservable(userInput: string): Observable<ISupplierResponse[]> {
        if (userInput == null) {
            userInput = 'a';
        }
        const sieveString = new SieveString();
        sieveString.addFilters([
            {
                key: SieveFilter.Supplier.Name,
                operator: SieveOperator.Contains,
                value: userInput
            }
        ]);
        return this.dataService
            .getSuppliers(sieveString)
            .pipe(map(response => response.payload));
    }
    private _initSuppliersObservable() {
        this.suppliers = this.supplierSubject.pipe(
            debounceTime(this.DEBOUNCE_TIME),
            distinctUntilChanged(),
            tap(() => (this.isLoadingPreviousSupplier = true)),
            switchMap(term => {
                console.log(`SEARCH SUPPLIERS '${term}'`);
                return this._getSuppliersObservable(term).pipe(
                    takeUntil(this.supplierSubject.pipe(skip(1))),
                    catchError(() => of([])),
                    tap(() => (this.isLoadingPreviousSupplier = false))
                );
            })
        );
    }

    //vendors
    private _getVendorsObservable(
        userInput: string,
        type: EnergyOrGasContract
    ): Observable<IVendorResponse[]> {
        if (userInput == null) {
            userInput = 'a';
        }
        const sieveString = new SieveString();
        sieveString.addFilters([{
            key: SieveFilter.Distributor.Name,
            operator: SieveOperator.Contains,
            value: userInput
        }, {
            key: SieveFilter.Distributor.Type,
            operator: SieveOperator.Equal,
            value: type
        }]);
        return this.dataService
            .getDistributors(sieveString)
            .pipe(map(response => response.payload));
    }
    private _initVendorsObservable(type: EnergyOrGasContract): void {
        this.vendors = this.vendorsSubject.pipe(
            debounceTime(this.DEBOUNCE_TIME),
            distinctUntilChanged(),
            tap(() => (this.isLoadingPreviousVendor = true)),
            switchMap(term => {
                console.log(`SEARCH VENDORS '${term}'`);
                return this._getVendorsObservable(term, type).pipe(
                    takeUntil(this.vendorsSubject.pipe(skip(1))),
                    catchError(() => of([])),
                    tap(() => (this.isLoadingPreviousVendor = false))
                );
            })
        );
    }

    //client
    private _getClientObservable(userInput: string): Observable<IShadowGenericAnagraphic[]> {
        //sieve string
        const sieveStringCustomers = new SieveString();
        sieveStringCustomers.setPage(1);
        sieveStringCustomers.setPageSize(20);
        //filtro ricerca utente
        sieveStringCustomers.addFilters([
            {
                key: SieveFilter.Customer.Customer,
                operator: this.ricercaClientePerCodiceFiscaleOId
                    ? SieveOperator.Equal
                    : SieveOperator.Contains,
                value: userInput || 'a'
            }
        ]);
        // filtro anagraphicType
        if (this.contract.client.anagraphicType != null) {
            let sieveFilterObject: ISieveFilterObject;
            switch (this.contract.client.anagraphicType) {
                case AnagraphicType.Person:
                case AnagraphicType.AssociazioneOrCondominio:
                    sieveFilterObject = {
                        key: SieveFilter.Customer.AnagraphicType,
                        operator: SieveOperator.Equal,
                        value: this.contract.client.anagraphicType
                    };
                    break;
                case AnagraphicType.Company:
                case AnagraphicType.IndividualCompany:
                    sieveFilterObject = {
                        key: SieveFilter.Customer.AnagraphicTypeOR,
                        operator: SieveOperator.Equal,
                        value: [AnagraphicType.Company, AnagraphicType.IndividualCompany]
                    };
                    break;
                default:
                    sieveFilterObject = null;
            }
            if (sieveFilterObject != null) {
                sieveStringCustomers.addFilters([sieveFilterObject]);
                sieveStringCustomers.addSorts([
                    {
                        key: SieveSort.Customer.Denominazione,
                        order: SieveSortOrder.Asc
                    }
                ]);
            }
        }
        return this.dataService
            .getCustomersFromAgent(this.him ? this.him.id : 0, this.contract.contract.brand, sieveStringCustomers)
            .pipe(map(response => response.payload));
    }
    private _initClientsObservable() {
        this.clients = this.clientsSubject.pipe(
            debounceTime(this.DEBOUNCE_TIME),
            distinctUntilChanged(),
            tap(() => (this.isLoadingClients = true)),
            switchMap(term => {
                console.log(`SEARCH CLIENTS '${term}'`);
                if (!term) {
                    term = '';
                }
                return this._getClientObservable(term).pipe(
                    takeUntil(this.clientsSubject.pipe(skip(1))),
                    catchError(() => of([])),
                    tap(() => (this.isLoadingClients = false))
                );
            })
        );
    }

    //referral
    private _getReferralObservable(userInput: string): Observable<IShadowGenericAnagraphic[]> {
        //sieve string
        const sieveStringCustomers = new SieveString();
        sieveStringCustomers.setPage(1);
        sieveStringCustomers.setPageSize(20);
        //filtro ricerca utente
        sieveStringCustomers.addFilters([
            {
                key: SieveFilter.Customer.Customer,
                operator: this.ricercaClientePerCodiceFiscaleOId
                    ? SieveOperator.Equal
                    : SieveOperator.Contains,
                value: userInput || 'a'
            }
        ]);
        return this.dataService
            .getCustomersFromAgentForReferral(this.him ? this.him.id : 0, this.contract.contract.brand, sieveStringCustomers)
            .pipe(map(response => {

                if (this.contract.client.referral) {

                    this.referral = response.payload.find((referral) => {
                        return referral.id === this.contract.client.referral;
                    });
                }

                return response.payload.filter((referral) => referral.id !== this.contract.client.id);
            }));
    }
    private _initReferralsObservable() {
        this.referrals = this.referralSubject.pipe(
            debounceTime(this.DEBOUNCE_TIME),
            distinctUntilChanged(),
            tap(() => (this.isLoadingReferrals = true)),
            switchMap(term => {
                console.log(`SEARCH REFERRAL CUSTOMERS '${term}'`);
                if (!term) {
                    term = '';
                }
                return this._getReferralObservable(term).pipe(
                    takeUntil(this.referralSubject.pipe(skip(1))),
                    catchError(() => of([])),
                    tap(() => (this.isLoadingReferrals = false))
                );
            })
        );
    }

    //agents
    private _getAgentsObservable(userInput: string): Observable<IVeryShortUser[]> {
        const ss = new SieveString();
        //brand
        ss.addFilters([
            {
                key: SieveFilter.User.Brand,
                operator: SieveOperator.Equal,
                value: this.contract.contract.brand
            }
        ]);

        // exclude disabled users
        ss.addFilters([{
            key: SieveFilter.User.IsDisabled,
            operator: SieveOperator.Equal,
            value: false
        }]);

        // exclude backoffice operators
        /* --> a backoffice-operator cannot create a contract for him self even if he has
        * the correct permissions */
        ss.addFilters([
            {
                key: SieveFilter.User.Role,
                operator: SieveOperator.NotEqual,
                value: PataviumRole.BackOfficeOperator
            }
        ]);
        //fulltext search
        if (userInput != null && userInput.length > 0) {
            ss.addFilters([
                {
                    key: SieveFilter.User.User,
                    operator: SieveOperator.Contains,
                    value: userInput
                },
                {
                    key: SieveFilter.User.IsDisabled,
                    operator: SieveOperator.Equal,
                    value: false
                }
            ]);
        }
        //exclude me if I cannot create contracts for myself
        if (SessionStorageService.sessionInfo.permitContracts === ContractPermission.Others) {
            ss.addFilters([
                {
                    key: SieveFilter.User.Id,
                    operator: SieveOperator.NotEqual,
                    value: SessionStorageService.sessionInfo.userId
                }
            ]);
        }
        return this.dataService.getSuggestUsers(ss).pipe(map(response => response.payload));
    }
    private _initAgentsObservable(): void {
        this.agents = this.agentsSubject.pipe(
            debounceTime(this.DEBOUNCE_TIME),
            distinctUntilChanged(),
            tap(() => (this.isLoadingAgents = true)),
            switchMap(term => {
                console.log(`SEARCH AGENTS '${term}'`);
                return this._getAgentsObservable(term).pipe(
                    takeUntil(this.agentsSubject.pipe(skip(1))),
                    catchError(() => of([])),
                    tap(() => (this.isLoadingAgents = false))
                );
            })
        );
    }

    //pricelists
    private _getPricelistsObservable(
        userInput: string,
        type: CatalogType
    ): Observable<IVeryShortCatalog[]> {
        const pricelistString = new SieveString();
        if (userInput != null && userInput.length > 0) {
            pricelistString.addFilters([
                {
                    key: SieveFilter.Catalog.Catalog,
                    operator: SieveOperator.Contains,
                    value: userInput
                }
            ]);
        }
        pricelistString.addFilters(this.globals.pricelistToDateIntervalFilters(true));
        pricelistString.addSorts([this.globals.pricelistToDateSortDesc]);
        pricelistString.addFilters([
            {
                key: SieveFilter.Catalog.HasCte,
                operator: SieveOperator.Equal,
                value: 'true'
            },
            {
                key: SieveFilter.Catalog.Brand,
                operator: SieveOperator.Equal,
                value: String(Number(this.contract.contract.brand))
            }
        ]);
        // aggiungi il filtro Generali se è verificata una di queste condizioni:
        // - esistono dei siti (più di uno) di cui almeno uno con un listino associato (dipende dalla proprietà isGenerali dei listini presenti)
        //      - - Questa regola vale per tutti gli utenti tranne quelli con ruolo admin.
        //      - - Non deve essere applicata se c'é solo un sito: con un solo sito deve essere possibile cambiare tra listini generali e non-generali.
        // - il brand è diverso da patavium (sempre false)
        // - il contratto è business (sempre false)
        let isGeneraliFilterValue: boolean = null;
        let numberOfSites = this.contract.pods.length + this.contract.pdrs.length;
        if (this.isANewTechnicalData) {
            numberOfSites += 1;
        }
        if (this.contract.contract.typeContract === TypeContract.Business) {
            isGeneraliFilterValue = false;
        } else if (this.contract.contract.brand !== BrandType.Patavium) {
            isGeneraliFilterValue = false;
        } else if (numberOfSites > 1 && this.sessionInfo.role !== PataviumRole.Admin) {
            const isGeneraliList: boolean[] = [];
            // considera solo i siti con listino:
            // se tutti i siti aggiunti non hanno un listino, non bisogna applicare nessun filtro
            for (const pod of this.contract.pods) {
                if (pod.idCatalog != null) {
                    if (pod.isGenerali == null) {
                        console.warn(`Found isGenerali  == null for catalog ${pod.idCatalog}`);
                    }
                    isGeneraliList.push(pod.isGenerali);
                }
            }
            for (const pdr of this.contract.pdrs) {
                if (pdr.idCatalog != null) {
                    if (pdr.isGenerali == null) {
                        console.warn(`Found isGenerali  == null for catalog ${pdr.idCatalog}`);
                    }
                    isGeneraliList.push(pdr.isGenerali);
                }
            }
            if (isGeneraliList.length) {
                isGeneraliFilterValue = isGeneraliList.some(b => b === true);
            }
        }
        if (isGeneraliFilterValue != null) {
            pricelistString.addFilters([{
                key: SieveFilter.Catalog.IsGenerali,
                operator: SieveOperator.Equal,
                value: isGeneraliFilterValue.toString()
            }]);
        }

        return this.dataService
            .getSuggestPricelistsWithType(type, pricelistString, this.him.id)
            .pipe(map(response => response.payload));
    }
    private _initPricelistsObservable(type: CatalogType): void {
        this.pricelists = this.pricelistsSubject.pipe(
            debounceTime(this.DEBOUNCE_TIME),
            distinctUntilChanged(),
            tap(() => (this.isLoadingPricelists = true)),
            switchMap(term => {
                console.log(`SEARCH PRICELISTS ENERGY '${term}'`);
                return this._getPricelistsObservable(term, type).pipe(
                    takeUntil(this.pricelistsSubject.pipe(skip(1))),
                    catchError(() => of([])),
                    tap(() => (this.isLoadingPricelists = false))
                );
            })
        );
    }

    // INIT DATA
    initData() {
        this.isInitFinished = false;
        this.updatePageConfig();
        //unsubscribe previous subscriptions
        if (!this.contractSubscription.closed) {
            this.contractSubscription.unsubscribe();
        }
        //contracts
        const sieveStringContract = new SieveString(this.sieveConf);
        //set value
        const valuePhaseOR = [];
        this.phaseFilters.activeFilters.map((po) => {

            if (po.phase === PhaseContract.CancelForChangingOfMind) {

                valuePhaseOR.push(PhaseContract.CancelForChangingOfMindEnerp);
                valuePhaseOR.push(PhaseContract.CancelForChangingOfMind);

            } else if (po.phase === PhaseContract.Rejected) {

                valuePhaseOR.push(PhaseContract.Rejected);
                valuePhaseOR.push(PhaseContract.CancelForCMOR);
                valuePhaseOR.push(PhaseContract.SwitchingRejected);

            } else {

                valuePhaseOR.push(po.phase);

            }

        });

        sieveStringContract.addFilters([
            {
                key: SieveFilter.Contract.ContractPhaseOR,
                operator: SieveOperator.Equal,
                value: valuePhaseOR
            }
        ]);

        this.contractSubscription = this.contractService
            .getContractsForTable(sieveStringContract, this.searchprop, this.searchval)
            .pipe(
                tap(response => {
                    this.contracts = response.payload;
                    this.rows = response.total;
                }),
                catchError(err => {
                    console.info(`Caught error: `, err);
                    this.toastr.error(
                        `Si è verificato un errore tentando di accedere alla lista dei contratti`
                    );
                    this.contracts = [];
                    this.rows = 0;
                    return EMPTY;
                }),
                finalize(() => {
                    if (this.contractSubscription != null) {
                        this.contractSubscription.unsubscribe();
                    }
                    this.isInitFinished = true;
                    // emit updated event
                    const updated_event = this.internalEventsService.EVENTS.UPDATE_DATA.CONTRACTS.DONE;
                    console.debug(`Emitting event ${updated_event.description}`);
                    updated_event.emit();
                })
            )
            .subscribe();
    }

    // CRUD CONTRACT
    createNewContract(templateRef: any) {
        //set variables
        this.modalMode = ModalMode.Create;
        this._setVariablesBeforeOpeningContractModal(new FormContractResponse());
        this.contract.contract.brand = BrandType.Patavium;
        //finally open the modal
        this._openModal(templateRef);
    }

    public async previousModalContract(contract: IFormContractResponse, dismissModal = false) {
        if (this._previousModal === PreviousModalForConflict.Edit) {
            await this._editContract(
                this.templateSpecificContract,
                contract.contract.id,
                dismissModal
            );
        } else if (this._previousModal === PreviousModalForConflict.ChangePhase) {
            await this.changeContractPhase(
                this.templateChangePhase,
                contract.contract.id,
                dismissModal
            );
        } else {
            console.error('_previousModal not managed.');
        }
        this.initData();
    }

    async editContract(
        templateRef: any,
        tableContract: TableContractModel,
        dismissModal = false,
        forceSession: boolean = false
    ) {
        if (!this.tableContractIsEditable(tableContract)) {
            console.warn(`The contract is not editable`, tableContract);
            return;
        }
        const id = tableContract.id;
        await this._editContract(templateRef, id, dismissModal, forceSession);
    }

    private async _editContract(
        templateRef: any,
        id: number,
        dismissModal = false,
        forceSession: boolean = false
    ) {
        this._previousModal = PreviousModalForConflict.Edit;
        //get contract
        if (dismissModal) {
            this.modalService.dismissAll();
        }
        const contract = await this._getContract(id);
        this.contractEditBackup = contract;
        //set variables
        this.modalMode = ModalMode.Edit;
        this._setVariablesBeforeOpeningContractModal(contract);
        //finally open the modal
        this._openModal(templateRef, forceSession);
    }

    async infoContract(templateRef: any, id: number) {
        // get contract
        const contract = await this._getContract(id);
        //set variables
        this.modalMode = ModalMode.Info;
        this._setVariablesBeforeOpeningContractModal(contract);
        //finally open the modal
        this._openModal(templateRef);
    }

    async changeContractPhase(
        templateRef: any,
        contractId: number,
        dismissModal = false,
        forceSession: boolean = false
    ) {
        console.debug(`changeContractPhase`, templateRef, contractId, dismissModal);
        if (dismissModal) {
            this.modalService.dismissAll();
        }
        // get contract
        this._previousModal = PreviousModalForConflict.ChangePhase;
        const contract = await this._getContract(contractId);
        this.contractEditBackup = contract;
        //set variables
        this.modalMode = ModalMode.ChangePhase;
        this._setVariablesBeforeOpeningContractModal(contract);
        //finally open the modal
        this._openModal(templateRef, forceSession);
    }

    async removeContract(
        templateRef: any,
        tableContract: TableContractModel,
        forceSession: boolean = false
    ) {
        if (!this.tableContractIsDeletable(tableContract)) {
            console.warn(`The contract is not deletable`, tableContract);
            return;
        }
        const id = tableContract.id;
        await this._removeContract(templateRef, id, forceSession);
    }

    private async _removeContract(templateRef: any, id: number, forceSession: boolean) {
        this.modalMode = ModalMode.Delete;
        const contract = await this._getContract(id);
        this._setVariablesBeforeOpeningContractModal(contract);
        this._openModal(templateRef, forceSession);
    }

    setContractNotes() {
        if (this.noteAggiunte != null && (this.iAmAgency || this.iAmAgencyOperator || this.iAmAgent)) {
            this.noteAggiunte = this.noteAggiunte.trim();
            const notesToAdd = `Note aggiunte il ${new Date().toLocaleString('it-IT')} dall'utente ${SessionStorageService.username.get()}:\n\t${this.noteAggiunte}`;
            if (this.contract.contract.note != null) {

                this.contract.contract.note = notesToAdd + "\n" + this.contract.contract.note;

                // this.contract.contract.note += "\n";
                // this.contract.contract.note += notesToAdd;
            } else {
                this.contract.contract.note = notesToAdd;
            }
        }
    }

    saveContract(closeModal: boolean = true, showMessages: boolean = true): void {
        this.isSavingContract = true;
        console.trace('Saving contract');
        this.contract.contract.note = this.noteOriginali;

        // set notes
        this.setContractNotes();

        // associate portaunamico
        if (this.referral && this.referral.id) {
            this.contract.client.referral = this.referral.id;
            // this.associatePortaUnAmico(this.referral.id, this.contract.client.id);
        }

        // set idAgent (don't modify it in changePhase mode)
        if (this.modalMode === ModalMode.Create || this.modalMode === ModalMode.Edit) {
            this.contract.idAgent = this.him.id; //whether it's defined or not
        }

        //set new phase depending on role
        if (this.modalMode === ModalMode.Create && this.phaseIsNull) {
            switch (SessionStorageService.sessionInfo.role) {
                case PataviumRole.BackOfficeOperator:
                    this.contract.contract.phase = PhaseContract.ToConfirmByPatavium;
                    break;
                case PataviumRole.AgencyOperator:
                    if (this.isTeleselling) {
                        this.contract.contract.phase = PhaseContract.InAttesaDiAdesione;
                    } else {
                        this.contract.contract.phase = PhaseContract.ToConfirmByPatavium;
                    }
                    break;
                case PataviumRole.Agency:
                case PataviumRole.Agent:
                    this.contract.contract.phase = PhaseContract.ToConfirmByAgency;
                    break;
            }
        }

        // set validation phase
        if (this.contract.contract.phase === PhaseContract.AttesaChiamataVerifica) {
            this.contract.validateAs = PhaseContract.Exportable;
        }

        console.debug(`Saving contract `, this.contract);
        this.contractService
            .createOrUpdateContractForTable(this.contract)
            .pipe(
                map(async response => {
                    console.debug(`Received response saving contract`, response);
                    // show successfully saved contract message
                    if (showMessages) {
                        const title = 'Successo';
                        const message = this.getSavedContractMessage(response.item.phase, this.modalMode);
                        this.toastr.success(message, title);
                    }
                    // associate portaunamico
                    const contract = await this._getContract(response.item.id);
                    if (contract.client && contract.client.id && this.referral && this.referral.id) {
                        this.associatePortaUnAmico(this.referral.id, contract.client.id);
                    }

                    if (this.modalMode === ModalMode.Create) {
                        this.initData();
                    } else {
                        const indexElement = this.contracts.findIndex(
                            c => c.id === response.item.id
                        );
                        if (indexElement >= 0) {
                            this.contracts[indexElement] = response.item;
                            const numberOfActiveFilters = this.phaseFilters.activeFilters.length;
                            const contractPhaseIsInActiveFilters = this.phaseFilters.activeFilters.map(f => f.phase).includes(response.item.phase);
                            console.debug(`Contract saved. There are '${numberOfActiveFilters}' active filter(s) ` +
                                `and contract's phase is ${contractPhaseIsInActiveFilters ? 'included' : 'not included'}`);
                            if (numberOfActiveFilters > 0 && !contractPhaseIsInActiveFilters) {
                                this.contracts.splice(indexElement, 1);
                            }
                        }
                    }
                    const successResponse: IRrs<IFormContractRequest, ITableContractModel> = {
                        request: this.contract,
                        response: response.item,
                        success: true
                    };
                    if (closeModal) {
                        this.closeModal();
                    }
                    return successResponse;
                }),
                catchError((err: HttpErrorResponse) => {
                    console.error(`Caught error saving contract`, err);
                    if (err.status === 412) {
                        this.modalService.dismissAll();
                        this._openModal(this.templateSolveConflict);
                    } else {
                        if (showMessages) {
                            this.toastr.error('Errore in fase di salvataggio');
                        }
                    }
                    this.contract.contract.note = this.noteOriginali;
                    const failureResponse: IRrs<IFormContractRequest, ITableContractModel> = {
                        request: this.contract,
                        response: null,
                        success: false
                    };
                    return of(failureResponse);
                }),
                finalize(() => {
                    console.debug(`Finalizing saving contract`);
                    this.isSavingContract = false;
                })
            )
            .subscribe();
    }

    async saveContractAsDraft() {
        this.contract.contract.phase = PhaseContract.Draft;
        await this.saveContract();
    }

    downloadParcel(): void {
        if (this.isANewContract) {
            this.toastr.error(`Prima di generare il plico contrattuale è necessario salvare il contratto`, `Attenzione`);
            return;
        }
        this.isSavingContract = true;
        this.toastr.info('Attendere la generazione del plico');
        this.contractService.downloadParcel(this.contract)
            .pipe(
                tap(resp => {
                    this.toastr.success(`Plico contrattuale correttamente scaricato`);
                    this.closeModal();
                }),
                catchError(err => {
                    console.error(`Error downloading contract parcel`, err);
                    this.toastr.error(
                        'Errore durante lo scaricamento del plico contrattuale.\n' +
                        `Salvare il contratto per non perdere eventuali modifiche effettuate.`,
                        'Attenzione',
                        { closeButton: true, disableTimeOut: true });
                    return EMPTY;
                }),
                finalize(() => this.isSavingContract = false)
            )
            .subscribe();
    }

    sendStandardParcelEmail(): void {
        if (this.showSendStandardParcelButton && this.showSendAdesioneADistanzaParcelButton) {
            return this.askForConfirmation('normalParcel');
        }
        return this.sendParcel(false);
    }

    sendAdesioneADistanzaParcel(): void {
        if (this.showSendStandardParcelButton && this.showSendAdesioneADistanzaParcelButton) {
            return this.askForConfirmation('adesioneADistanza');
        }
        return this.sendParcel(true);
    }

    sendParcelToEsignHandler(): void {
        if (true) {
            //TODO: in attesa di chiarire meglio sotto quali condizioni chiedere conferma
            return this.askForConfirmation('sendParcelToEsign');
        }
        return this.sendParcelToEsign();
    }


    /**
     * Sends the current contract parcel for electronic signing via the contract service.
     *
     * @return {void} Does not return a value.
     */
    sendParcelToEsign(): void {
        this.contractService.sendParcelToEsign(this.contract)
            .pipe(
                tap(resp => {
                    if (resp.isSuccess) {
                        this.toastr.success(`Plico contrattuale correttamente inviato al cliente per la firma digitale`);
                        this.closeModal();
                    } else {
                        console.error(`Error sending contract parcel to esign: ${resp.errorMessage}`);
                        this.toastr.error(`Errore durante l'invio del plico contrattuale alla firma digitale.`,
                            `Attenzione`, { closeButton: true, disableTimeOut: true });
                    }
                }),
                catchError(err => {
                    console.error(`Error sending contract parcel to esign.`, err);
                    this.toastr.error(
                        `Errore durante l'invio del plico contrattuale al cliente per la firma digitale.`,
                        'Attenzione',
                        { closeButton: true, disableTimeOut: true });
                    return EMPTY;
                }),
                finalize(() => this.isSavingContract = false)
            )
            .subscribe();
    }

    sendParcel(adesioneADistanza: boolean): void {
        if (adesioneADistanza == null) {
            this.toastr.error(`È necessario scegliere se utilizzare il processo di adesione a distanza o meno.`);
            return;
        }
        // change adesioneADistanza property
        const oldAdesioneADistanza = this.contract.contract.adesioneADistanza;
        this.contract.contract.adesioneADistanza = adesioneADistanza;
        if (this.isANewContract) {
            this.toastr.error(`Prima di inviare il plico contrattuale è necessario salvare il contratto`, `Attenzione`);
            return;
        }
        this.toastr.info(`Attendere l'invio del plico`);
        this.isSavingContract = true;
        this.contractService.sendParcel(this.contract)
            .pipe(
                tap(resp => {
                    if (resp.isSuccess) {
                        this.toastr.success(`Plico contrattuale correttamente inviato`);
                        this.closeModal();
                    } else {
                        console.error(`Error sending contract parcel: ${resp.errorMessage}`);
                        this.toastr.error(`Errore durante l'invio del plico contrattuale.\n` +
                            `Salvare il contratto per non perdere eventuali modifiche effettuate.`,
                            `Attenzione`, { closeButton: true, disableTimeOut: true });
                        this.contract.contract.adesioneADistanza = oldAdesioneADistanza;
                    }
                }),
                catchError(err => {
                    console.error(`Error sending contract parcel.`, err);
                    this.toastr.error(
                        `Errore durante l'invio del plico contrattuale.\n` +
                        `Salvare il contratto per non perdere eventuali modifiche effettuate.`,
                        'Attenzione',
                        { closeButton: true, disableTimeOut: true });
                    this.contract.contract.adesioneADistanza = oldAdesioneADistanza;
                    return EMPTY;
                }),
                finalize(() => this.isSavingContract = false)
            )
            .subscribe();
    }

    deleteContract() {
        const id = this.contract.contract.id;
        if (id) {
            this.contractService.removeContract(id).subscribe(
                result => {
                    this.initData();
                    this.toastr.success('Contratto rimosso dal sistema', 'Successo', {
                        closeButton: true
                    });
                    this.closeModal();
                },
                err => { }
            );
        }
    }

    private _clearFlags() {
        this.closeTecnicalData();
        this.isANewCustomer = null;
        this.isRecapitiEditable = false;
        this.wantToEditClient = null;
        this.isEditable = null;
        this.isDeletable = null;
        this.isTechnicalDataPanelOpened = null;
        this.isSettingHim = false;
        this.audioAdesioneContrattualeHasBeenListenedTo = false;
        this.audioAdesioneContrattualeNeedToBeListenedTo = false;
    }

    private async _setVariablesBeforeOpeningContractModal(_contract: IFormContractResponse): Promise<void> {
        console.log(`SET VARIABLES BEFORE OPENING MODAL: start`);
        // always
        this._clearFlags();
        this.contract = new FormContractRequest(new FormContractResponse(_contract));
        console.log(`contract RESPONSE =`, _contract);
        console.log(`contract REQUEST =`, this.contract);
        this.pod = null;
        this.pdr = null;
        this.tecnicalDataCity = null;
        this.phase = new Phase(_contract.contract.phase);

        this.availablePhases = _contract.availablePhases.map((phase) => {

            if (phase === PhaseContract.CancelForChangingOfMindEnerp) {

                return new Phase(PhaseContract.CancelForChangingOfMind)

            } else if (phase === PhaseContract.CancelForCMOR || phase === PhaseContract.SwitchingRejected) {

                return new Phase(PhaseContract.Rejected);

            } else {

                return new Phase(phase);

            }

        });


        this.noteOriginali = this.contract.contract.note;
        this.noteAggiunte = null;
        this.canDoChiamataBenvenuto = _contract.agent.canDoChiamataBenvenuto;
        this.canDoPortaUnAmico = _contract.agent.canDoPortaUnAmico;

        if (_contract.client.referral) {
            this.dataService.getCustomer(_contract.client.referral).subscribe((response) => {
                this.referral = response.item;
            });
        } else {
            this.referral = null;
        }

        if (this.contract.contract.chiamataBenvenutoPreferredDate) {

            this.contract.contract.chiamataBenvenutoPreferredDate = new Date(this.contract.contract.chiamataBenvenutoPreferredDate);

        }

        if (this.contract.contract.chiamataBenvenutoPreferredTimeFrom) {

            this.contract.contract.chiamataBenvenutoPreferredTimeFrom = new Date(this.contract.contract.chiamataBenvenutoPreferredTimeFrom);

        }

        if (this.contract.contract.chiamataBenvenutoPreferredTimeTo) {

            this.contract.contract.chiamataBenvenutoPreferredTimeTo = new Date(this.contract.contract.chiamataBenvenutoPreferredTimeTo);

        }

        if (this.contract.contract.debtorClientName || this.contract.contract.debtorFiscalCode) {

            this.contract.contract.sepaChoice = true;

        }

        this.isEditable = _contract.isEditable;
        this.isDeletable = _contract.isDeletable;
        this.isVirgin = this._isVirgin(_contract);

        this.contractAttachments = ContractAttachments.fromContractFiles(
            new FormContractResponse(_contract).files
        );
        this.setSafeUrlForAudioFiles();

        this.hasDelega = this.contract.contract.delegaName != null ||
            this.contract.contract.delegaLastname != null ||
            this.contract.contract.delegaCf != null ||
            this.contractAttachments.delega.length > 0;

        this.tecnicalDataIndex = null;

        // set clientCity
        this.clientCity = this._newCityOrNull(
            this.contract.client.istatCodeCity,
            this.contract.client.city,
            this.contract.client.shortProvince
        );
        // set recapitiCity
        this.recapitiCity = this._newCityOrNull(
            this.contract.contract.istatCodeCity,
            this.contract.contract.city,
            this.contract.contract.shortProvince
        );
        //client
        this.client = new ShadowGenericAnagraphic(new ShadowCustomerCreate(this.contract.client));
        /* -> async part at the end*/
        // set him
        console.log('avviso : ' + _contract.agent.id);
        if (_contract.agent.id) {
            //this is the case of an existing contract
            this.him = new ShadowUser(_contract.agent);
        } else {
            //this is the case of a new contract
            if (this.canModifyContractForOthers === false) {
                this.setHim(this.sessionInfo.userId);
            } else {
                this.him = null;
            }
        }
        this.audioAdesioneContrattualeHasBeenListenedTo = false;

        const idx = this.vocalOrdersListened.findIndex((vorder) => {

            return vorder.contractId === this.contract.contract.id && vorder.listened === false;

        });

        if (idx !== -1) {

            this.vocalOrdersListened.slice(idx, 1);

        }


        if (
            this.him != null &&
            this.him.reliabilityPercentage != null &&
            this.him.reliabilityPercentage >= 0 &&
            this.him.reliabilityPercentage <= 100
        ) {
            this.audioAdesioneContrattualeNeedToBeListenedTo = await this.getAudioAdesioneContrattualeNeedToBeListenedTo(
                this.contract.contract.id,
                100 - this.him.reliabilityPercentage
            );
        } else {
            this.audioAdesioneContrattualeNeedToBeListenedTo = true;
        }

        //set brands (after him)
        this.brands = this.getBrandsObjects();

        //autocomplete subjects
        this._initAgentsObservable();
        this._initClientsObservable();
        this._initReferralsObservable();
        this._initClientCitiesObservable();
        this._initRecapitiCitiesObservable();
        this._initSignatureCitiesObservable();

        // case modalMode
        switch (this.modalMode) {
            case ModalMode.Create:
            case ModalMode.Edit:
            case ModalMode.Info:
            case ModalMode.ChangePhase:
                break;
            default:
                this.modalMode = ModalMode.Info;
                console.error('Error: default modal mode.');
                await this._setVariablesBeforeOpeningContractModal(_contract);
        }

        console.log(`SET VARIABLES BEFORE OPENING MODAL: end`);
    }

    private async getAudioAdesioneContrattualeNeedToBeListenedTo(
        contractId: number,
        percentage: number
    ): Promise<boolean> {
        try {
            console.debug(`getAudioAdesioneContrattualeNeedToBeListenedTo`, contractId, percentage);
            if (percentage == null || percentage > 100 || percentage < 0) {
                console.warn(
                    `While trying to determine if contract audio must be listened to percentage=${percentage} has been found`
                );
                return true;
            }
            if (contractId == null) {
                // no warning needed: it could be new contract
                return false;
            }
            if (percentage === 0) {
                return false;
            }
            if (percentage === 100) {
                return true;
            }

            /*const hasher = async function(s: string): Promise<number> {
                const digest = crypto.subtle.digest('SHA-1', new TextEncoder().encode(s));
                const sum = new Uint8Array(await digest).reduce(
                    (previousValue, currentValue) => previousValue + currentValue
                );

                // tslint:disable-next-line:no-bitwise
                const result = sum & sum;
                return result;
            };*/
            const hasher = async function (s: string): Promise<number> {
                let hash = 0;
                if (s.length === 0) {
                    return hash;
                }
                for (let i = 0; i < s.length; i++) {
                    const char = s.charCodeAt(i);
                    // tslint:disable-next-line:no-bitwise
                    hash = (hash << 5) - hash + char;
                    // tslint:disable-next-line:no-bitwise
                    hash = hash & hash; // Convert to 32bit integer
                }
                return hash;
            };

            const trueOrFalse: (n: number) => Promise<boolean> = async n => {
                const h: number = await hasher(n.toString());
                return h % 1000 > percentage * 10;
            };

            return trueOrFalse(contractId);
        } catch (e) {
            console.warn(
                `Exception while trying to determine if contract audio must be listened to`,
                e
            );
            return true;
        }
    }

    private openTemplateRef(ref: TemplateRef<any>, options: NgbModalOptions): NgbModalRef {
        return this.modalService.open(ref, options);
    }

    private _openModal(templateRef: any, forceSession: boolean = false) {
        console.debug(`_openModal`, templateRef, forceSession);
        const options: NgbModalOptions = {
            centered: true,
            size: 'lg',
            windowClass: 'modal-xxl',
            backdrop: 'static',
            keyboard: false
        };
        const openTemplateRef = () => {
            this.modalRef = this.openTemplateRef(templateRef, options);
        };
        this.isSavingContract = false;
        if (this.isEditMode || this.isChangePhaseMode || this.isDeleteMode) {
            const contractId = this.contract.contract.id;
            if (!contractId) {
                console.error(`Missing contract id: cannot handle concurrency`);
                return;
            }
            this.lockId = null;
            this.contractLockSubscription = this.lockContract(contractId, forceSession)
                .pipe(
                    tap(lockId => {
                        if (this.lockId == null) {
                            openTemplateRef();
                            this.lockId = lockId;
                        }
                    }),
                    catchError(err => {
                        if (err instanceof HttpErrorResponse && err.status === 409) {
                            this.backupModalMode = JSON.parse(JSON.stringify(this.modalMode));
                            this.lockTemplateRef = templateRef;
                            this.openLockConflictModal();
                            return EMPTY;
                        } else {
                            console.error(err);
                            this.closeModal();
                            return EMPTY;
                        }
                    }),
                    finalize(() => {
                        if (this.lockId != null) {
                            this.deleteContractLock(this.lockId);
                            this.lockId = null;
                        }
                        this.contractLockSubscription.unsubscribe();
                    })
                )
                .subscribe();
        } else {
            openTemplateRef();
        }
    }

    private _clearContractModalVariablesOnClose() {
        this._clearFlags();
        this.him = null;
        this.pod = null;
        this.pdr = null;
        this.agents = null;
        this.clients = null;
        this.tecnicalDataIndex = null;
        this.modalMode = null;
        this.tecnicalDataType = null;
        this.attachTypeUploading = null; // used for activate fa-refresh
        this.clientCities = null;
        this.recapitiCities = null;
        this.tecnicalDataCities = null;
        this.clientCity = null;
        this.noteAggiunte = null;
        this.noteOriginali = null;
    }

    closeModal() {
        if (this.contractLockSubscription instanceof Subscription) {
            this.contractLockSubscription.unsubscribe();
        }
        if (this.lockId != null) {
            this.deleteContractLock(this.lockId);
            this.lockId = null;
        }
        this.closeTecnicalData();
        this._clearContractModalVariablesOnClose();
        this.modalService.dismissAll();
    }

    // CONTRACT
    private _resetContractPreservingImportantThings() {
        console.debug(`Resetting contract preserving important information`);
        // reset contract preserving the typeRequest supply
        //save important things
        const id = this.contract.contract.id;
        const typeReq = this.contract.contract.typeRequestSupply;
        const pods = this.contract.pods;
        const pdrs = this.contract.pdrs;
        const brand = this.contract.contract.brand;
        const createdDateTime = this.contract.contract.createdDateTime;
        //reset contract
        this.contract = new FormContractRequest(new FormContractRequest());
        /* Remove contractAttachments
        Di fatto, creando una nuova istanza del contratto, stiamo cancellando anche i file.
        Se non creassimo una nuova istanza anche per l'oggetto che incapsula le informazioni degli allegati,
        ci ritroveremmo con gli allegati mostrati sulla ui, ma non presenti nella richiesta che arriva al backend.*/
        this.contractAttachments = new ContractAttachments();
        this.clientCity = null;
        //set important things
        this.contract.contract.id = id;
        this.contract.contract.typeRequestSupply = typeReq;
        this.contract.pods = pods;
        this.contract.pdrs = pdrs;
        this.contract.contract.brand = brand;
        this.contract.contract.createdDateTime = createdDateTime;
    }
    setPrivateContract() {
        this._resetContractPreservingImportantThings();
        //set private contract and private client
        this.contract.contract.typeContract = TypeContract.Private;
        this.contract.client.anagraphicType = AnagraphicType.Person;
    }

    setBusinessContract() {
        this._resetContractPreservingImportantThings();
        //set business contract and private client
        this.contract.contract.typeContract = TypeContract.Business;
        this.contract.client.anagraphicType = AnagraphicType.Company;
    }

    setClientType(anagType: AnagraphicType) {
        switch (anagType) {
            case AnagraphicType.Person:
                this._resetContractPreservingImportantThings();
                if (this.isANewCustomer === true && this.client != null) {
                    this.client.anagraphicType = anagType;
                } else {
                    this.client = null;
                }
                this.contract.client.anagraphicType = anagType;
                this.contract.contract.typeContract = TypeContract.Private;
                break;
            case AnagraphicType.Company:
            case AnagraphicType.IndividualCompany:
            case AnagraphicType.AssociazioneOrCondominio:
                this._resetContractPreservingImportantThings();
                if (this.isANewCustomer === true && this.client != null) {
                    this.client.anagraphicType = anagType;
                } else {
                    this.client = null;
                }
                this.contract.client.anagraphicType = anagType;
                this.contract.contract.typeContract = TypeContract.Business;
                break;
            default:
                console.error(`Cannnot set customer type to '${anagType}': case not handled`);
        }
    }

    private _isVirgin(contractResp: IFormContractResponse) {
        const isEditable = contractResp.isSignatureEditable;
        return isEditable == null || isEditable === true;
    }

    // CRUD POD - PDR
    addNewTechnicalData(technicalDataType: TechnicalDataType) {
        return this.openTecnicalData(null, technicalDataType);
    }

    saveTechnicalData(technicalDataType: TechnicalDataType) {
        switch (technicalDataType) {
            case TechnicalDataType.Pod:
                return this._savePod();
            case TechnicalDataType.Pdr:
                return this._savePdr();
            default:
                return null;
        }
    }
    private _savePod() {
        const pod = this.pod;
        // initialize index and array
        const index = this.tecnicalDataIndex;
        const array = this.contract.pods;

        // TODO(??): check index is compatible with array.length

        //update
        if (index != null) {
            // edit and notify
            array[index] = pod;
            this.toastr.success('POD aggiornato correttamente', 'Successo', {
                closeButton: true
            });
        }
        // save
        else {
            // push and notify
            array.push(pod);
            this.toastr.success('POD salvato correttamente', 'Successo', {
                closeButton: true
            });
        }

        //close and reset variables
        this.closeTecnicalData();
    }
    private _savePdr() {
        const pdr = this.pdr;
        // initialize index and array
        const index = this.tecnicalDataIndex;
        const array = this.contract.pdrs;

        // TODO(??): check index is compatible with array.length

        //update
        if (index != null) {
            // edit and notify
            array[index] = pdr;
            this.toastr.success('PDR aggiornato correttamente', 'Successo', {
                closeButton: true
            });
        }
        // save
        else {
            // push and notify
            array.push(pdr);
            this.toastr.success('PDR salvato correttamente', 'Successo', {
                closeButton: true
            });
        }

        //close and reset variables
        this.closeTecnicalData();
    }

    closeTecnicalData() {
        this.tecnicalDataIndex = null;
        this.tecnicalDataType = null;
        this.isTechnicalDataPanelOpened = false;
        this.pod = null;
        this.pdr = null;
        this.podCodeStatusList = [];
        this.pdrCodeStatusList = [];
        this.podCode = null;
        this.pdrCode = null;
        this.remiCode = null;
        this.isAValidTecnicalDataCode = null;
        this.tecnicalDataCity = null;
        this.previousVendor = null;
        this.previousSupplier = null;
        this.vatExemptionCodes = [];
        this.pricelist = null;
        this.phaseToChangeTo = null;
    }
    openTecnicalData(index: number, tecnicalDataType: TechnicalDataType) {
        //close if open
        this.closeTecnicalData();
        // wrong conditions: nissing tecnicalDataType || missing index || negative index
        if (!tecnicalDataType || (index != null && index < 0)) {
            return null;
        }
        // this is the case of an EXISTING POD/PDR
        if (index != null) {
            let _array: Array<any>;
            switch (tecnicalDataType) {
                case TechnicalDataType.Pod:
                    _array = this.contract.pods;
                    break;
                case TechnicalDataType.Pdr:
                    _array = this.contract.pdrs;
                    break;
                default:
                    return null;
            }
            // check if index is compatible with _array.length
            // (allow index === _array.length for info and edit mode)
            if (index > _array.length) {
                return null;
            }
            switch (tecnicalDataType) {
                case TechnicalDataType.Pod:
                    this.pod = new ShadowSitePodCatalogs(this.contract.pods[index]);
                    if (this.pod.durationContractMonth == null) {
                        this.pod.durationContractMonth = this.DefaultMonthsDuration;
                    }
                    this.tecnicalDataCity = this._newCityOrNull(
                        this.pod.istatCodeCity,
                        this.pod.city,
                        this.pod.shortProvince
                    );
                    this._initSuppliersObservable();
                    this.previousSupplier = this._newSupplierOrNull({
                        idCode: this.pod.codEnerpPreviousSupplier,
                        name: this.pod.previousSupplier
                    });
                    this._initVendorsObservable(EnergyOrGasContract.Energy);
                    this.previousVendor = this._newVendorOrNull(
                        this.pod.codEnerpVendor,
                        this.pod.previousVendor
                    );
                    this._initPricelistsObservable(CatalogType.Energy);
                    this._newPriceListOrNull(this.pod.idCatalog, CatalogType.Energy).then(resp => {
                        this.pricelist = resp;
                        if (this.pricelist != null) {
                            this.loadSupplyOffer(
                                this.pricelist.supplyOfferFamily,
                                EnergyOrGasContract.Energy
                            );
                        }
                    });

                    break;
                case TechnicalDataType.Pdr:
                    this.pdr = new ShadowSitePdrCatalogs(this.contract.pdrs[index]);
                    if (this.pdr.vat == null) {
                        this.pdr.vat = this.DefaultVAT;
                    }
                    if (this.pdr.durationContractMonth == null) {
                        this.pdr.durationContractMonth = this.DefaultMonthsDuration;
                    }
                    this.tecnicalDataCity = this._newCityOrNull(
                        this.pdr.istatCodeCity,
                        this.pdr.city,
                        this.pdr.shortProvince
                    );
                    this._initSuppliersObservable();
                    this.previousSupplier = this._newSupplierOrNull({
                        idCode: this.pdr.codEnerpPreviousSupplier,
                        name: this.pdr.previousSupplier
                    });
                    this._initVendorsObservable(EnergyOrGasContract.Gas);
                    this.previousVendor = this._newVendorOrNull(
                        this.pdr.codEnerpVendor,
                        this.pdr.previousVendor
                    );
                    this._initPricelistsObservable(CatalogType.Gas);
                    this._newPriceListOrNull(this.pdr.idCatalog, CatalogType.Gas).then(resp => {
                        this.pricelist = resp;
                        if (this.pricelist != null) {
                            this.loadSupplyOffer(
                                this.pricelist.supplyOfferFamily,
                                EnergyOrGasContract.Gas
                            );
                        }
                    });
                    break;
                default:
                    return null;
            }
        }
        // this is the case of a NEW POD/PDR
        else {
            switch (tecnicalDataType) {
                case TechnicalDataType.Pod:
                    this.pod = new ShadowSitePodCatalogs(new ShadowSitePodCatalogs());
                    this.pod.durationContractMonth = this.DefaultMonthsDuration;
                    this.pod.billingPeriod = BillingPeriod.Monthly;
                    this.pod.startDateExpected = null;
                    this._newPriceListOrNull(this.pod.idCatalog, CatalogType.Energy).then(
                        resp => (this.pricelist = resp)
                    );
                    this._initSuppliersObservable();
                    this._initVendorsObservable(EnergyOrGasContract.Energy);
                    this._initPricelistsObservable(CatalogType.Energy);
                    if (this.isPrivateType) {
                        this.pod.typeTensionLink = TypeTensionLink.Low220;
                    }
                    // set declaration
                    if (this.contract.pods.length > 0) {
                        this.pod.declaration = this.contract.pods[0].declaration;
                    } else if (this.contract.pdrs.length > 0) {
                        this.pod.declaration = this.contract.pdrs[0].declaration;
                    }
                    break;

                case TechnicalDataType.Pdr:
                    this.pdr = new ShadowSitePdrCatalogs(new ShadowSitePdrCatalogs());
                    this.pdr.startDateExpected = null;
                    this.pdr.vat = this.DefaultVAT;
                    this.pdr.durationContractMonth = this.DefaultMonthsDuration;
                    this.pdr.billingPeriod = BillingPeriod.Monthly;
                    this._newPriceListOrNull(this.pdr.idCatalog, CatalogType.Gas).then(
                        resp => (this.pricelist = resp)
                    );
                    this._initSuppliersObservable();
                    this._initVendorsObservable(EnergyOrGasContract.Gas);
                    this._initPricelistsObservable(CatalogType.Gas);
                    // set declaration
                    if (this.contract.pods.length > 0) {
                        this.pdr.declaration = this.contract.pods[0].declaration;
                    } else if (this.contract.pdrs.length > 0) {
                        this.pdr.declaration = this.contract.pdrs[0].declaration;
                    }
                    break;

                default:
                    return null;
            }
        }
        // init tecnicalDatacities observable
        this._initTechnicalDataCitiesObservable();
        //set tecnicalDataType
        this.tecnicalDataType = tecnicalDataType;
        // remember index
        this.tecnicalDataIndex = index;
        // open panel
        this.isTechnicalDataPanelOpened = true;
    }
    removeTecnicalData(index: number, tecnicalDataType: TechnicalDataType) {
        console.log('Index to remove : ' + index);
        switch (tecnicalDataType) {
            case TechnicalDataType.Pod:
                this.contract.pods.splice(index, 1);
                break;
            case TechnicalDataType.Pdr:
                this.contract.pdrs.splice(index, 1);
                break;
        }
        this.closeTecnicalData();
    }
    copyAddressFromClientAnagraphic(tecnicalDataType: TechnicalDataType) {
        let _city: ICity = null;
        if (
            this.contract.client.city != null &&
            this.contract.client.istatCodeCity != null &&
            this.contract.client.province != null &&
            this.contract.client.shortProvince != null
        ) {
            _city = new City({
                name: this.contract.client.city,
                codIstatCity: this.contract.client.istatCodeCity,
                province: this.contract.client.province,
                shortProvince: this.contract.client.shortProvince,
                idProvince: null,
                postalCode: null
            });
        }
        switch (tecnicalDataType) {
            case TechnicalDataType.Pod:
                this.pod.address = this.contract.client.address;
                this.pod.numberAddress = this.contract.client.numberAddress;
                this.pod.postalCode = this.contract.client.postalCode;
                this.setPodCity(_city);
                break;
            case TechnicalDataType.Pdr:
                this.pdr.address = this.contract.client.address;
                this.pdr.numberAddress = this.contract.client.numberAddress;
                this.pdr.postalCode = this.contract.client.postalCode;
                this.setPdrCity(_city);
                break;
        }
    }

    //VERIFY POD AND PDR
    async verifyPodCode(
        codeInput: HTMLInputElement,
        clean: boolean = false,
        add: boolean = false
    ): Promise<void> {
        //value
        const code: string = codeInput.value;
        console.log(`POD code='${code}'`);
        if (code == null || code.length === 0) {
            this.isAValidTecnicalDataCode = false;
            return;
        }
        //verify it
        const status = await this.dataService
            .podIsBusy(code)
            .toPromise()
            .then(response => !response.payload)
            .catch(err => {
                console.error(err);
                return null;
            });
        this.isAValidTecnicalDataCode = status;
        //add to list of pod codes (if it's not present or if it'not already a contract's pod)
        if (add === true) {
            const podCS: IPodCodeStatus = {
                podCode: code,
                status: status
            };
            for (let i = 0; i <= this.podCodeStatusList.length; i++) {
                if (i === this.podCodeStatusList.length) {
                    this.podCodeStatusList.push(podCS);
                    break;
                }
                const item = this.podCodeStatusList[i];
                if (item.podCode === podCS.podCode) {
                    break;
                }
            }
        }
        //clean input element
        if (clean === true && status != null) {
            codeInput.value = null;
            this.podCode = null;
        }
    }
    async verifyPdrCode(
        codeInput: HTMLInputElement,
        clean: boolean = false,
        add: boolean = false
    ): Promise<void> {
        //values
        const code: string = codeInput.value;
        console.log(`PDR code='${code}'`);
        if (code == null || code.length === 0) {
            this.isAValidTecnicalDataCode = false;
            return;
        }
        //verify them
        const status = await this.dataService
            .pdrIsBusy(code)
            .toPromise()
            .then(response => !response.payload)
            .catch(err => {
                console.error(err);
                return null;
            });
        this.isAValidTecnicalDataCode = status;
        //add to pdr-remi codes list (if it's not present or if it'not already a contract's pdr)
        if (add === true) {
            const pdrRemiCS: IPdrCodeStatus = {
                pdrCode: code,
                status: status
            };
            for (let i = 0; i <= this.pdrCodeStatusList.length; i++) {
                if (i === this.pdrCodeStatusList.length) {
                    this.pdrCodeStatusList.push(pdrRemiCS);
                    break;
                }
                const item = this.pdrCodeStatusList[i];
                if (item.pdrCode === pdrRemiCS.pdrCode) {
                    break;
                }
            }
        }
        // clean inputs elements
        if (clean === true && status != null) {
            codeInput.value = null;
            this.pdrCode = null;
            this.remiCode = null;
        }
    }
    addPodToContract(podCS: IPodCodeStatus) {
        console.log(`ADD POD`, podCS);
        if (podCS.status === true) {
            const pod = new ShadowSitePodCatalogs(new ShadowSitePodCatalogs());
            pod.podCode = podCS.podCode.toUpperCase();
            this.contract.pods.push(pod);
            //remove from list
            this.podCodeStatusList = this.podCodeStatusList.filter(
                item => item.podCode !== podCS.podCode
            );
        }
    }
    addPdrToContract(pdrAndRemiCS: IPdrCodeStatus) {
        console.log(`ADD PDR`, pdrAndRemiCS);
        if (pdrAndRemiCS.status === true) {
            const pdr = new ShadowSitePdrCatalogs(new ShadowSitePdrCatalogs());
            pdr.pdrCode = pdrAndRemiCS.pdrCode.toUpperCase();
            this.contract.pdrs.push(pdr);
            //remove from list
            this.pdrCodeStatusList = this.pdrCodeStatusList.filter(
                item => item.pdrCode !== pdrAndRemiCS.pdrCode
            );
        }
    }

    // ADD - REMOVE ATTACHMENTS
    uploadIdentityDocument(target: HTMLInputElement, attachType: AttachType) {
        if (attachType == null) {
            this.toastr.info(
                `Prima di poter allegare un documento di identità è necessario selezionare un "Tipo di documento"`,
                'Attenzione'
            );
            return;
        }
        return this.uploadContractAttachment(target, attachType);
    }
    async uploadContractAttachment(target: HTMLInputElement, attachType: AttachType) {

        const files = target.files;
        if (files && files.length) {
            this.attachTypeUploading = attachType; //start fa-refresh
            const file = files[0];
            const description = null;
            const idOwner = this.him.id;
            let timestamped = false;
            if (attachType === 16 || attachType === 25) timestamped = true;
            const timestampInfos: ITimestampInfos = null;
            const attachment = new Attachment({
                id: null,
                label: null,
                loading: true,
                name: file.name,
                type: attachType,
                uuid: null,
                uploadDateTime: null,
                safeUrl: null,
                chiamataPreAdesioneDateTime: null
            });
            await this._uploadContractAttachment(attachment, file, description, idOwner, timestampInfos, timestamped);
        }
        target.value = null; //reset input value
        this.attachTypeUploading = null; //stop fa-refresh
    }
    private _unLinkDocument(file: IContractAttachment) {
        //remove file from contract
        const index = this.contract.files.findIndex(f => f.idFile === file.id);
        if (index === -1) {
            console.error('Impossibile rimuovere il file desiderato');
            return;
        }
        this.contract.files.splice(index, 1);
    }
    unLinkDocument(file: IContractAttachment) {
        this._unLinkDocument(file);
        //remove file from attachmentsMeta
        this.contractAttachments.removeAttachment(file);
    }

    // REMOVE SELECTED CLIENT
    private _clearLegalRepresentativeSection() {
        this.contract.representative = new ShadowRepresentativeCreate(
            new ShadowRepresentativeCreate()
        );
    }
    private _clearIdentityDocumentSection() {
        this.contract.contract.typeDocument = null;
        this.contract.contract.documentNumber = null;
        this.contract.contract.documentGrantedBy = null;
        this.contract.contract.documentExpirationDate = null;
        //clear attachments and files
        for (const _file of this.contractAttachments.documento_identita) {
            this._unLinkDocument(_file);
            this.contractAttachments.removeAttachment(_file);
        }
    }
    removeClient() {
        console.log(`REMOVE CLIENT: start`);
        //set empty client
        const oldAnagraphicType = this.contract.client.anagraphicType;
        this.contract.client = new ShadowCustomerCreate(new ShadowCustomerCreate());
        if (oldAnagraphicType != null) {
            this.setClientType(oldAnagraphicType);
        }

        // clear identity document section
        this._clearIdentityDocumentSection();
        // clear recapiti
        this._clearRecapiti();
        // clear legal representative:
        this._clearLegalRepresentativeSection();
        // clear isANewCustomer
        this.isANewCustomer = null;
        // clear wantToEditClient
        this.wantToEditClient = null;
        this.clientCity = null;
        console.log(`REMOVE CLIENT: end`);
    }

    // POD-PDR
    getMonth(date: Date) {
        return this.utilsDate.getMonth(date);
    }
    setPodType(type: PodType) {
        this.pod.podType = type;
        switch (type) {
            case PodType.BTUsoDomestico:
            case PodType.BTUsoDomesticoPompeCalore:
                this.pod.vat = this.DefaultDomesticVAT;
                break;
            default:
                this.pod.vat = this.DefaultVAT;
        }
    }

    //EXPORT CONTRACT CSV
    openCSVModal(ref: TemplateRef<any>) {
        this.exportToBeSend = false;
        this.modalMode = ModalMode.ExportCSV;
        this.csvStartDate = null;
        this.csvEndDate = null;
        this.typeExport = ExportType.Simple;
        this._openModal(ref);
    }

    getCSV(): void {
        if (this.csvButtonDisabled) {
            console.debug("CSV button is disabled. Cannot get CSV export file.");
            return;
        }
        this.getCsvFileOfContracts();
    }

    getCsvFileOfContracts(): void {
        switch (this.typeExport) {
            case ExportType.Simple:
                return this.getCsvFileForSimpleExport();
            case ExportType.Gas:
                return this.getCsvFileForSpecificExport(EnergyOrGasContract.Gas);
            case ExportType.Energy:
                return this.getCsvFileForSpecificExport(EnergyOrGasContract.Energy);
            case ExportType.PhoneCall:
                return this.getCsvFileForPhoneCallExport();
            default:
                console.error(`TypeExport ${this.typeExport} not handled. cannot get CSV export file`);
        }
    }

    get csvButtonDisabled() {
        return this.csvStartDate == null || this.csvEndDate == null || this.isWaitingExport;
    }

    // GENERAL

    //new or null
    private _newVendorOrNull(idCode: string, name: string) {
        const isValid = (str: string) => {
            return str != null && str.length > 0;
        };
        if (isValid(idCode) && isValid(name)) {
            return new Vendor({ idCode: idCode, name: name });
        }
        return null;
    }
    private _newCityOrNull(istatCode: string, city: string, shortProvince: string) {
        const isValid = (str: string) => {
            return str != null && str.length > 0;
        };
        let _city: ICity = null;
        if (isValid(istatCode) && isValid(city) && isValid(shortProvince)) {
            const c: ICityResponse = {
                codIstatCity: istatCode,
                name: city,
                shortProvince: shortProvince,
                province: null,
                idProvince: null,
                postalCode: null
            };
            _city = new City(c);
        }
        /* console.log(
      `
      _newCityOrNull: city =`,
      _city
    );*/
        return _city;
    }
    private _newSupplierOrNull(supp: ISupplierResponse) {
        const isValid = (str: string) => {
            return str != null && str.length > 0;
        };
        if (isValid(supp.idCode) && isValid(supp.name)) {
            return new Supplier(supp);
        }
        return null;
    }
    private async _newPriceListOrNull(id: number, type: CatalogType): Promise<ICatalog> {
        this.isLoadingPricelists = true;
        let pricelist: ICatalog = null;
        if (id) {
            await this.dataService
                .getPricelistById(id, type)
                .toPromise()
                .then(resp => (pricelist = resp.item.catalog))
                .catch(console.error);
        }
        this.isLoadingPricelists = false;
        return pricelist;
    }

    //modal mode
    get isInfoMode() {
        return this.modalMode === ModalMode.Info;
    }
    get isCreateMode() {
        return this.modalMode === ModalMode.Create;
    }
    get isEditMode() {
        return this.modalMode === ModalMode.Edit;
    }
    get isChangePhaseMode() {
        return this.modalMode === ModalMode.ChangePhase;
    }
    get isDeleteMode(): boolean {
        return this.modalMode === ModalMode.Delete;
    }

    //user permission
    get canEditPod() {
        return (this.isANewPod || this.podIsEditable) && this.iHaveSomeContractPermission;
    }
    get canEditPdr() {
        return (this.isANewPdr || this.pdrIsEditable) && this.iHaveSomeContractPermission;
    }
    get iHaveSomeContractPermission() {
        return (
            SessionStorageService.sessionInfo.permitContracts !== ContractPermission.None &&
            SessionStorageService.sessionInfo.permitContracts !== ContractPermission.NotAssign
        );
    }
    get canModifyContractForOthers() {
        return (
            SessionStorageService.sessionInfo.permitContracts === ContractPermission.Others ||
            SessionStorageService.sessionInfo.permitContracts === ContractPermission.SelfAndOthers
        );
    }

    get canSelectNewAgent() {
        const agentHasNotBeenSelectedYet: boolean = this.him == null;
        const thereIsNotAnExistingCustomer: boolean =
            this.isANewCustomer === true ||
            (this.isANewCustomer == null && this.contract.client.id == null);
        return agentHasNotBeenSelectedYet || thereIsNotAnExistingCustomer;
    }

    get agentCanDoTelesales(): boolean {
        return this.him != null && this.him.teleselling === true;
    }

    //recapiti
    private _clearRecapiti() {
        this.contract.contract.atPlace = null;
        this.contract.contract.address = null;
        this.contract.contract.numberAddress = null;
        this.contract.contract.city = null;
        this.contract.contract.province = null;
        this.contract.contract.postalCode = null;
        this.contract.contract.shortProvince = null;
    }
    copyRecapiti() {
        if (this.isRecapitiEditable === false) {
            console.log('COPYING RECAPITI');
            if (this.contract.client.firstName) {
                if (this.contract.client.lastName) {
                    this.contract.contract.atPlace =
                        this.contract.client.firstName + ' ' + this.contract.client.lastName;
                } else {
                    this.contract.contract.atPlace = this.contract.client.firstName;
                }
            }

            if (this.contract.client.address) {
                this.contract.contract.address = this.contract.client.address;
            }

            if (this.contract.client.numberAddress) {
                this.contract.contract.numberAddress = this.contract.client.numberAddress;
            }

            if (this.contract.client.city) {
                this.contract.contract.city = this.contract.client.city;
            }

            if (this.contract.client.province) {
                this.contract.contract.province = this.contract.client.province;
            }

            if (this.contract.client.shortProvince) {
                this.contract.contract.shortProvince = this.contract.client.shortProvince;
            }

            if (this.contract.client.postalCode) {
                this.contract.contract.postalCode = this.contract.client.postalCode;
            }

            if (this.contract.client.istatCodeCity) {
                this.contract.contract.istatCodeCity = this.contract.client.istatCodeCity;
            }

            //client city
            if (this.clientCity != null) {
                this.setRecapitiCity(this.clientCity);
            }
        }
    }
    editRecapiti() {
        this.isRecapitiEditable = true;
    }

    openDocumentPdf(fd, filename, typeDown: DownloadType = DownloadType.STREAM) {
        return this.fileDownloadService.downloadAndOpenDocument(fd, filename, typeDown);
    }

    openMassiveContractCSV(type: EnergyOrGasContract) {
        this.contractService.exportCSV(type).subscribe(
            result => {
                this.fileDownloadService.generateAndDownload(
                    result,
                    ContentTypeSupported.Csv,
                    'export_contracts',
                    true
                );
            },
            err => {
                console.error(err);
            }
        );
    }

    sendMassiveContractCSV(type: EnergyOrGasContract) {
        this.contractService.sendExportCSV(type).subscribe(
            () => {
                this.toastr.success('Contratti esportati in Enerp!', 'Successo', {
                    closeButton: true
                });
            },
            err => {
                console.error(err);
            }
        );
    }

    openMassiveContractAttachment(type: EnergyOrGasContract) {
        this.contractService.exportAttachments(type).subscribe(
            result => {
                this.fileDownloadService.generateAndDownload(
                    result,
                    ContentTypeSupported.Zip,
                    'expcontr_attachments',
                    true
                );
            },
            err => {
                console.error(err);
            }
        );
    }

    //contract client
    insertNewClient() {
        this.isANewCustomer = true;
        //set new client
        const oldAnagType = this.contract.client.anagraphicType;

        this.client = new ShadowGenericAnagraphic(new ShadowGenericAnagraphic());
        this.client.anagraphicType = oldAnagType;

        this.contract.client = new ShadowGenericAnagraphic(new ShadowGenericAnagraphic());
        this.contract.client.anagraphicType = oldAnagType;
    }
    selectExistingClient() {
        console.log(`SELECT EXISTING CUSTOMER`);
        this.client = null;
        this.isANewCustomer = false;
        this.ricercaClientePerCodiceFiscaleOId = false;
    }
    setWantToEditClientTrue() {
        this.wantToEditClient = true;
    }
    getContractClient() {
        const client = new ShadowCustomerCreate(this.contract.client);
        client.anagraphicType = undefined;
        const newClient = new ShadowCustomerCreate(new ShadowCustomerCreate());
        if (JSON.stringify(client) === JSON.stringify(newClient)) {
            return null;
        }
        return this.contract.client;
    }

    private getBrandsObjects(): IBrandObject[] {
        try {
            const _brands = JSON.parse(
                SessionStorageService.brands.get()
            ) as BrandType[];
            return BrandObjects.filter(bo => _brands.includes(bo.value));
        } catch (e) {
            console.error(`There's somthing wrong with brands`);
            return [];
        }
    }

    //contract phase
    get thereAreSomeAvailablePhases() {
        return this.availablePhases.length > 0;
    }

    //brand
    get thereIsABrand(): boolean {
        return this.contract.contract.brand != null;
    }

    //who am I?
    get iAmAdmin(): boolean {
        return this.sessionInfo.iAmAdmin;
    }
    get iAmPataviumOperator(): boolean {
        return this.sessionInfo.iAmPataviumOperator;
    }
    get iAmAgency(): boolean {
        return this.sessionInfo.iAmAgency;
    }

    get iAmAgent(): boolean {
        return this.sessionInfo.iAmAgent;
    }

    get iAmAgencyOperator(): boolean {
        return this.sessionInfo.iAmAgencyOperator;
    }

    get iAmSpecializedOperator(): boolean {
        return this.sessionInfo.iAmSpecializedOperator;
    }

    get iCanDoTelesales(): boolean {
        return this.sessionInfo.teleselling;
    }

    get iCanHandlePataviumBrand(): boolean {
        return this.sessionInfo.permitBrands != null && this.sessionInfo.permitBrands.includes(BrandType.Patavium);
    }

    get pdrOfferNeedValidation() {
        return ContractComponent.offerNeedValidation(
            this.pdr.supplyOfferResponsible,
            this.pdr.supplyOfferSize,
            this.pricelist
        );
    }

    get podOfferNeedValidation() {
        return ContractComponent.offerNeedValidation(
            this.pod.supplyOfferResponsible,
            this.pod.supplyOfferSize,
            this.pricelist
        );
    }

    //him
    get himIsDefined(): boolean {
        return this.him != null;
    }

    //filters
    private _initPhaseFilters(activeFilters: IPhaseObject[] = null) {
        const role: PataviumRole = this.sessionInfo.role;
        const canDoTelesales: boolean = this.sessionInfo.teleselling;
        const canDoAdesioneADistanza: boolean = this.sessionInfo.canDoAdesioneADistanza;
        if (activeFilters == null) {
            activeFilters = [];
        }
        const active_phases: PhaseContract[] = activeFilters.map((po) => {

            if (po.phase === PhaseContract.CancelForChangingOfMindEnerp) {

                return PhaseContract.CancelForChangingOfMind

            } else if (po.phase === PhaseContract.CancelForCMOR || po.phase === PhaseContract.SwitchingRejected) {

                return PhaseContract.Rejected;

            } else {

                return po.phase;

            }

        });
        this.phaseFilters = new ContractPhaseFilters(role, active_phases, canDoTelesales, canDoAdesioneADistanza);
    }

    togglePhasesMenu() {

        if (this.showPhases) {

            this.showPhases = false;

            if (this.phaseFiltersHaveChanged) {
                this.page = SieveString.DEAFULT_PAGE;
                this.initData();
                this.phaseFiltersHaveChanged = false;
            }

        } else {

            this.showPhases = true;

        }
    }

    closePhaseMenu() {

        this.showPhases = false;

        if (this.phaseFiltersHaveChanged) {
            this.page = SieveString.DEAFULT_PAGE;
            this.initData();
            this.phaseFiltersHaveChanged = false;
        }

    }

    setActivePhaseFilter(obj: IPhaseObject): void {

        if (obj.phase === PhaseContract.CancelForChangingOfMind) {

            this.phaseFilters.setActive(PhaseContract.CancelForChangingOfMindEnerp);
            this.phaseFilters.setActive(PhaseContract.CancelForChangingOfMind);

        } else if (obj.phase === PhaseContract.Rejected) {

            this.phaseFilters.setActive(PhaseContract.Rejected);
            this.phaseFilters.setActive(PhaseContract.CancelForCMOR);
            this.phaseFilters.setActive(PhaseContract.SwitchingRejected);

        } else {

            this.phaseFilters.setActive(obj.phase);

        }

        this.phaseFiltersHaveChanged = true;
    }

    setInactivePhaseFilter(obj: IPhaseObject): void {
        if (obj.phase === PhaseContract.CancelForChangingOfMind) {

            this.phaseFilters.setInactive(PhaseContract.CancelForChangingOfMindEnerp);
            this.phaseFilters.setInactive(PhaseContract.CancelForChangingOfMind);

        } else if (obj.phase === PhaseContract.Rejected) {

            this.phaseFilters.setInactive(PhaseContract.Rejected);
            this.phaseFilters.setInactive(PhaseContract.CancelForCMOR);
            this.phaseFilters.setInactive(PhaseContract.SwitchingRejected);

        } else {

            this.phaseFilters.setInactive(obj.phase);

        }


        this.phaseFiltersHaveChanged = true;
    }

    getPhaseObject(phase: PhaseContract): IPhaseObject {
        let phaseObj: IPhaseObject = new PhaseObject(null);
        for (const po of PhaseObjects) {
            if (po.phase === phase) {

                if (po.phase === PhaseContract.CancelForChangingOfMindEnerp) {

                    phaseObj = new PhaseObject({
                        phase: PhaseContract.CancelForChangingOfMind,
                        label: 'ANNULLATO PER RIPENSAMENTO',
                        icon: 'fas fa-angry',
                        color: Color.Red,
                        icon2: null,
                        color2: null
                    });

                } else if (po.phase === PhaseContract.CancelForCMOR || po.phase === PhaseContract.SwitchingRejected) {

                    phaseObj = new PhaseObject({
                        phase: PhaseContract.Rejected,
                        label: 'RESPINTO',
                        icon: 'fas fa-times-circle',
                        color: Color.Red,
                        icon2: null,
                        color2: null
                    });

                } else {

                    phaseObj = po;

                }

            }
        }
        return phaseObj;
    }

    //export errors
    podHasAnExportError(pod: IShadowSitePodCatalogs) {
        return pod.lastExportError != null && pod.lastExportError.length > 0;
    }
    get thereIsAnExportErrorOnPod() {
        return this.podHasAnExportError(this.pod);
    }
    pdrHasAnExportError(pdr: IShadowSitePdrCatalogs) {
        return pdr.lastExportError != null && pdr.lastExportError.length > 0;
    }
    get thereIsAnExportErrorOnPdr() {
        return this.pdrHasAnExportError(this.pdr);
    }
    podHasAnExportPhase(pod: IShadowSitePodCatalogs) {
        return pod.lastExportPhase != null;
    }

    pdrHasAnExportPhase(pdr: IShadowSitePdrCatalogs) {
        return pdr.lastExportPhase != null;
    }

    //ditta individuale
    get isIndividualCompany() {
        return this.contract.client.anagraphicType === AnagraphicType.IndividualCompany;
    }

    private _isClientA(anagType: AnagraphicType): boolean {
        if (this.contract != null && this.contract.client != null) {
            return this.contract.client.anagraphicType === anagType;
        }
        return false;
    }

    get isClientAPerson(): boolean {
        return this._isClientA(AnagraphicType.Person);
    }

    get isClientAGenericCompany(): boolean {
        return (
            this._isClientA(AnagraphicType.Company) ||
            this._isClientA(AnagraphicType.IndividualCompany)
        );
    }

    get isClientAnAssociazioneOrCondominio(): boolean {
        return this._isClientA(AnagraphicType.AssociazioneOrCondominio);
    }

    toggleCompanyType() {
        const anagraphicType = this.contract.client.anagraphicType;
        //if it's not a company exit
        if (
            anagraphicType !== AnagraphicType.Company &&
            anagraphicType !== AnagraphicType.IndividualCompany
        ) {
            return;
        }
        //if it'a company, change anagraphicType
        let newAnagraphicType = AnagraphicType.Company; //default
        if (anagraphicType === AnagraphicType.Company) {
            newAnagraphicType = AnagraphicType.IndividualCompany;
        }
        this.contract.client.anagraphicType = newAnagraphicType;
    }

    toggleIntestatarioConto(): void {

        this.contract.contract.sepaChoice = !this.contract.contract.sepaChoice;

        if (!this.contract.contract.sepaChoice) {

            this.contract.contract.debtorClientName = null;
            this.contract.contract.debtorFiscalCode = null;

        }
    }

    //contract/pod/pdr properies
    get brandIsPatavium(): boolean {
        return this.contract.contract.brand === BrandType.Patavium;
    }

    get brandIsAjoPatavium(): boolean {
        return this.contract.contract.brand === BrandType.Ajo;
    }

    get isBusinessType() {
        return this.contract.contract.typeContract === TypeContract.Business;
    }

    get isPrivateType() {
        return this.contract.contract.typeContract === TypeContract.Private;
    }

    private typeRequestSupplyIs(tr: TypeRequest): boolean {
        if (tr == null) {
            return this.contract.contract.typeRequestSupply == null;
        }
        return this.contract.contract.typeRequestSupply === tr;
    }

    get isSwitch() {
        return this.typeRequestSupplyIs(TypeRequest.Switch);
    }

    get isVoltura() {
        return this.typeRequestSupplyIs(TypeRequest.Voltura);
    }

    get isAttivazione(): boolean {
        return this.typeRequestSupplyIs(TypeRequest.Attivazione);
    }

    get isSubentro(): boolean {
        return this.typeRequestSupplyIs(TypeRequest.Subentro);
    }

    get isCambioPiano(): boolean {
        return this.typeRequestSupplyIs(TypeRequest.CambioPiano);
    }

    get isVolturaConAttivazione() {
        return this.typeRequestSupplyIs(TypeRequest.VolturaConAttivazione);
    }

    get thereIsNoTypeRequestSupply(): boolean {
        return !this.contract.contract.typeRequestSupply;
    }
    get isPodVatZero() {
        return this.pod && this.pod.vat != null && Number(this.pod.vat) === 0;
    }
    get isPdrVatZero() {
        return this.pdr && this.pdr.vat != null && Number(this.pdr.vat) === 0;
    }
    get thereIsAPodOrAPdr() {
        return this.contract.pods.length > 0 || this.contract.pdrs.length > 0;
    }
    get _tecnicalDataAreValid() {
        return this.thereIsAPodOrAPdr;
    } //TODO: now it check only the existence of a pod or a pdr
    get isANewPod() {
        return ContractComponent.podIsNew(this.pod);
    }
    get isANewPdr() {
        return ContractComponent.pdrIsNew(this.pdr);
    }
    get isANewContract() {
        return this.contract.contract.id == null;
    }
    get podIsEditable() {
        return ContractComponent.podIsEditable(this.pod);
    }
    get pdrIsEditable() {
        return ContractComponent.pdrIsEditable(this.pdr);
    }
    get isConfirmed(): boolean {
        return this.contract.contract.phase === PhaseContract.Exportable;
    }
    get isDraft(): boolean {
        return this.contract.contract.phase === PhaseContract.Draft;
    }
    get phaseIsNull(): boolean {
        return this.contract.contract.phase == null;
    }
    get isAdesioneADistanza(): boolean {
        return this.contract.contract.adesioneADistanza === true;
    }


    //fab visibility
    get canCreateContractFab() {
        return this.iHaveSomeContractPermission && !this.iAmAdmin;
    }
    //table visibility
    get canEditContractsTable() {
        return this.iHaveSomeContractPermission;
    }
    get canRemoveContractsTable() {
        return this.iHaveSomeContractPermission;
    }

    get showPhaseFilters(): boolean {
        const pred1 = this.contracts != null;
        const pred2 =
            this.iAmAdmin || this.iAmPataviumOperator || this.iAmAgency || this.iAmAgencyOperator || this.iAmAgent;
        return pred1 && pred2;
    }

    /* MODAL VISIBILITY */

    //agent
    get _canChooseAgent() {
        return this.canModifyContractForOthers;
    }
    get showChooseAgentSection() {
        return this._canChooseAgent && this.thereIsABrand;
    }
    //client type and operation
    get showClientAndOperationTypesSection() {
        return (
            (((this.iAmPataviumOperator &&
                this.contract.contract.brand != null &&
                this.him != null) ||
                (!this.iAmPataviumOperator && this._canChooseAgent && this.him != null) ||
                !this._canChooseAgent) &&
                this.thereIsABrand) ||
            (this.canChangeAgentForVisibility && this.thereIsABrand)
        );
    }
    //client data
    get _showClientData() {
        return (
            this.contract.contract.typeContract != null &&
            this.contract.contract.typeRequestSupply != null
        );
    }
    get showClientDataSection() {
        return this._showClientData;
    }
    // client data subsection
    get _clientDataAreValid() {
        //TODO: dipende dal contractType
        return true;
    } //TODO: now it always returns true
    get _thereIsAnExistingClient() {
        return this.getContractClient() != null;
    }
    get showSelectOrInsertClientButtons() {
        return !this._thereIsAnExistingClient;
    }
    get showSelectClientSubSection() {
        return (
            this.isANewCustomer === false &&
            this.getContractClient() == null &&
            !this.iAmSpecializedOperator
        );
    }
    get showSelectedClientDataSummmary() {
        return (
            !this.showSelectClientSubSection &&
            this.getContractClient() != null &&
            this._clientDataAreValid &&
            !this.isInfoMode
        );
    }
    get showEditClientDataSubSection() {
        return this.isANewCustomer || this.isInfoMode || this.wantToEditClient === true;
    }
    //client document
    get showIdentityDocumentSection() {
        return this._showClientData;
    }
    //legal representative
    get showLegalRepresentativeSection() {
        return (
            this._showClientData && this.contract.contract.typeContract === TypeContract.Business
        );
    }
    //recapiti
    get _minimumRecapitiSatisfied() {
        return !this.utilsString.isUndefinedOrNullOrEmpty(this.contract.client.firstName);
    }
    get showRecapitiSection() {
        return this._showClientData && this._minimumRecapitiSatisfied;
    }
    //send mode
    get showModeSendInvoiceSection() {
        return this._showClientData;
    }
    //payment method
    get showPaymentMethodSection() {
        return this._showClientData;
    }
    // pod/pdr
    get _showTecnicalData() {
        // TODO: necessario controllare che pod e pdr non siano null??
        return (
            this.thereIsAPodOrAPdr ||
            (this.contract.contract.modeSendInvoice != null &&
                this.contract.contract.modeSendInvoice.length &&
                this.contract.contract.paymentMode != null &&
                this.isInfoMode === false)
        ); //TODO: more restrictive conditions
    }
    get showAddTenicalDataSection() {
        return this._showTecnicalData;
    }
    get showPodSection() {
        return (
            this._showTecnicalData &&
            this.isTechnicalDataPanelOpened &&
            this.tecnicalDataType === TechnicalDataType.Pod
        );
    }
    get showPdrSection() {
        return (
            this._showTecnicalData &&
            this.isTechnicalDataPanelOpened &&
            this.tecnicalDataType === TechnicalDataType.Pdr
        );
    }
    get showTecnicalDataListSection() {
        return this.showAddTenicalDataSection;
    }
    get showSavePodButton() {
        const conditions = new VisibilityConditions();
        conditions.info = false;
        conditions.edit = (this.podIsEditable || this.isANewPod) && !this.iAmSpecializedOperator;
        conditions.create = true;
        conditions.changePhase = this.iAmPataviumOperator && this.podIsEditable;
        return conditions.getConditionOnModalMode(this.modalMode);
    }
    get showSavePdrButton() {
        const conditions = new VisibilityConditions();
        conditions.info = false;
        conditions.edit = (this.pdrIsEditable || this.isANewPdr) && !this.iAmSpecializedOperator;
        conditions.create = true;
        conditions.changePhase = this.iAmPataviumOperator && this.pdrIsEditable;
        return conditions.getConditionOnModalMode(this.modalMode);
    }

    //attachments
    get showAttachmentsSection() {
        return this.thereIsAPodOrAPdr && !this.isInfoMode;
    }

    get showChooseAttachTypeSection(): boolean {
        return !this.isInfoMode && this.contractAttachments.non_mappati.length > 0;
    }

    get showAllAttachmentsSection() {
        return this.isInfoMode && this.contractAttachments.getAllAttachments().length > 0;
    }

    get showPrivacySection(): boolean {
        return this.thereIsAPodOrAPdr;
    }

    get showDelegaSection(): boolean {
        return this.showPrivacySection;
    }

    //signature date
    get showSignatureDateSection() {
        return this.thereIsAPodOrAPdr;
    }

    get showVerificationCallSection(): boolean {
        return this.showPrivacySection
            && this.him != null
            && (this.him.needVerificationCall == null || this.him.needVerificationCall === true)
            && !this.isTeleselling;
    }

    get showChiamataBenvenutoSection(): boolean {
        return (this.iAmAdmin || this.iAmPataviumOperator || this.iAmAgency || this.iAmAgencyOperator || this.iAmAgent) && this.canDoChiamataBenvenuto;
    }

    get showRenounceOfChangeOfMindPeriodSection(): boolean {
        return this.showPrivacySection
            && (this.isAttivazione || this.isSubentro || this.isVolturaConAttivazione);
    }

    //note
    get showNoteSection() {
        return this._showClientData;
    }

    // parcel buttons
    get showActionButtons(): boolean {
        if (this.iAmSpecializedOperator) {
            return false;
        } else if (this.iAmPataviumOperator) {
            return !this.isANewContract && this.showNoteSection;
        } else {
            return !this.isANewContract && this.showNoteSection && (this.isVirgin || this.isDraft);
        }
    }

    get showDownloadParcelButton(): boolean {
        return this.showActionButtons;
    }

    get showSendStandardParcelButton(): boolean {
        if (this.isAdesioneADistanza) {
            return false;
        }
        if (this.iAmPataviumOperator) {
            return this.showNoteSection && (this.isVirgin || this.isDraft);
        } else {
            return this.showActionButtons;
        }
    }

    get showSendAdesioneADistanzaParcelButton(): boolean {
        if (this.iAmPataviumOperator) {
            return this.him != null &&
                this.him.canDoAdesioneADistanza &&
                this.sessionInfo.canDoAdesioneADistanza &&
                this.showNoteSection &&
                this.isDraft;
        } else {
            return this.sessionInfo.canDoAdesioneADistanza && this.showActionButtons;
        }
    }

    //save buttons
    get showSaveButtonSection() {
        return this._showClientData && this.modalMode !== ModalMode.Info;
    }

    //verify pod/pdr
    showVerifyPodButton(podCode: string) {
        if (podCode != null) {
            return podCode.length >= 13;
        }
        return false;
    }
    showVerifyPdrCodes(pdrCode: string) {
        if (pdrCode != null) {
            return pdrCode.length === 14;
        }
        return false;
    }

    //changePhase save button
    get showChangePhaseSaveButton() {
        return this.iAmPataviumOperator ?
            this.iHaveSomeContractPermission && this.thereAreSomeAvailablePhases
            : this.thereAreSomeAvailablePhases;
    }

    get needToSendSmsForAdesioneADistanza(): boolean {
        // ATTENZIONE: aggiornare il backend e viceversa se si modifica questa parte di codice
        return this.showChangePhaseSaveButton &&
            this.isPrivateType &&
            this.isAdesioneADistanza &&
            this.phase.id === PhaseContract.ToConfirmByPatavium &&
            this.phaseToChangeTo === PhaseContract.InAttesaDiAdesione;
    }

    get needToSendSmsForAttesaVocalOrder(): boolean {
        return this.showChangePhaseSaveButton &&
            this.isPrivateType &&
            this.phase.id === PhaseContract.ToConfirmByPatavium && this.phaseToChangeTo === PhaseContract.AttesaVocalOrder;
    }

    get needToSendSmsForChiamataDiBenvenuto(): boolean {

        return this.showChangePhaseSaveButton &&
            this.isPrivateType &&
            this.phase.id === PhaseContract.ToConfirmByPatavium && this.phaseToChangeTo === PhaseContract.AttesaChiamataBenvenuto && this.canDoChiamataBenvenuto;
    }

    get showAdesioneADistanzaSmsSendingWarning(): boolean {
        return this.needToSendSmsForAdesioneADistanza;
    }

    get showAttesaVocalOrderSmsSendingWarning(): boolean {
        return this.needToSendSmsForAttesaVocalOrder;
    }

    get showAttesaChiamataBenvenutoSmsSendingWarning(): boolean {
        return this.needToSendSmsForChiamataDiBenvenuto;
    }

    get changePhaseSaveButtonLabel(): string {
        if (this.showAdesioneADistanzaSmsSendingWarning || this.showAttesaVocalOrderSmsSendingWarning || this.showAttesaChiamataBenvenutoSmsSendingWarning) {
            return `Conferma e invia`;
        }
        return `Conferma`;
    }

    //titles
    get headerTitle() {
        switch (this.modalMode) {
            case ModalMode.Create:
                return 'Nuovo contratto';
            case ModalMode.Edit:
                return 'Modifica contratto ' + this.contract.contract.id.toString();
            case ModalMode.Info:
                return 'Informazioni contratto ' + this.contract.contract.id.toString();
            default:
                return 'Contratto';
        }
    }
    get podSectionTitle() {
        switch (this.modalMode) {
            case ModalMode.Create:
                return 'Nuovo POD';
            case ModalMode.Edit:
                if (this.isANewTechnicalData) {
                    return 'Nuovo POD';
                } else {
                    return 'Modifica POD';
                }
            case ModalMode.Info:
                return 'Info POD';
            default:
                return 'POD';
        }
    }
    get pdrSectionTitle() {
        switch (this.modalMode) {
            case ModalMode.Create:
                return 'Nuovo PDR';
            case ModalMode.Edit:
                if (this.isANewTechnicalData) {
                    return 'Nuovo PDR';
                } else {
                    return 'Modifica PDR';
                }
            case ModalMode.Info:
                return 'Info PDR';
            default:
                return 'PDR';
        }
    }
    get saveButtonLabel() {
        switch (SessionStorageService.sessionInfo.role) {
            case PataviumRole.BackOfficeOperator:
                return 'Conferma';
            case PataviumRole.Agency:
                return 'Salva';
            case PataviumRole.AgencyOperator:
                if (this.modalMode) {
                    switch (this.modalMode) {
                        case ModalMode.Create:
                            return 'Conferma';
                        case ModalMode.Edit:
                            return 'Salva';
                        default:
                            return 'Salva';
                    }
                }
                return 'Salva';
            case PataviumRole.Agent:
                return 'Conferma';
            default:
                return 'Salva';
        }
    }

    //STYLE
    redGreenOrLightBlue(bool: boolean): string {
        if (bool === true) {
            return 'green';
        } else if (bool === false) {
            return 'red';
        } else {
            return '#1c8dc9';
        }
    }
    faInfoCheckOrQuestion(bool: boolean) {
        if (bool === true) {
            return 'fa fa-check';
        } else if (bool === false) {
            return 'fa fa-times';
        } else {
            return 'fa fa-question-circle';
        }
    }
    resetIsAValidTechnicalDataCode() {
        this.isAValidTecnicalDataCode = null;
    }

    public setCsvFromDate(event) {
        this.csvStartDate = this.utilsDate.inputDateSetter(event);
    }

    public setCsvToDate(event) {
        this.csvEndDate = this.utilsDate.inputDateSetter(event);
    }

    get canChangeAgentForVisibility() {
        return (
            (SessionStorageService.sessionInfo.role === PataviumRole.Agency ||
                SessionStorageService.sessionInfo.role === PataviumRole.AgencyOperator) &&
            SessionStorageService.sessionInfo.customerVisibility ===
            CustomerVisibilityType.General
        );
    }

    public setTypeExport(type: ExportType) {
        this.typeExport = type;
    }

    //date picker options
    get startDateDisabler(): (date: NgbDate, current: { year: number; month: number }) => boolean {
        switch (this.contract.contract.typeRequestSupply) {
            case TypeRequest.Switch:
            case TypeRequest.CambioPiano:
                return (date: NgbDate, current: { year: number; month: number }) => date.day !== 1;
            case TypeRequest.Attivazione:
            case TypeRequest.Subentro:
            case TypeRequest.Voltura:
            case TypeRequest.VolturaConAttivazione:
                return (date: NgbDate, current: { year: number; month: number }) => false;
            default:
                return (date: NgbDate, current: { year: number; month: number }) => true;
        }
    }

    getStartDateExpectedForATechnicalData(): Date {
        const now = new Date();
        switch (this.contract.contract.typeRequestSupply) {
            case TypeRequest.Switch:
            case TypeRequest.Voltura:
            case TypeRequest.CambioPiano:
                now.setDate(1);
                now.setMonth(now.getMonth() + 1);
                return now;
            case TypeRequest.Attivazione:
            case TypeRequest.Subentro:
            case TypeRequest.VolturaConAttivazione:
            default:
                return now;
        }
    }

    setTypeRequestSupply(trs: TypeRequest) {
        /*TODO: si potrebbero resettare eventuali campi compilati utili solo in caso di voltura, se si passa da voltura ad un altro tipo.
        Prima di farlo chiedere a Patavium. Potrebbe essere possibile gestire la cosa come nel caso delle date di pod e pdr*/
        // check if it's the first assignment
        const itIsNotTheFirstAssignment = !this.typeRequestSupplyIs(null);
        // set the new value
        this.contract.contract.typeRequestSupply = trs;
        // update related properties
        if (itIsNotTheFirstAssignment) {
            if (this.contract.pods.length || this.contract.pdrs.length) {
                if (this.iAmPataviumOperator) {
                    this.toastr.info(
                        `Verranno cambiate le date di 'inizio fornitura' di POD e PDR.`,
                        'Attenzione'
                    );

                    this.changeAllStartDateExpected(this.getStartDateExpectedForATechnicalData());
                } else {
                    this.changeAllStartDateExpected(null);
                }

            }
            if (this.contract.contract.renounceOfChangeOfMindPeriod != null) {
                this.toastr.info(
                    `Verrà cancellata la preferenza circa la rinuncia al periodo di ripensamento`,
                    'Attenzione'
                );
                this.contract.contract.renounceOfChangeOfMindPeriod = null;
            }
        }
    }

    changeAllStartDateExpected(value: Date): void {
        if (this.contract.pods.length || this.contract.pdrs.length) {
            for (const pod of this.contract.pods) {
                if (ContractComponent.podIsEditable(pod) || ContractComponent.podIsNew(pod)) {
                    pod.startDateExpected = value;
                }
            }
            if (
                this.pod != null &&
                (ContractComponent.podIsEditable(this.pod) || ContractComponent.podIsNew(this.pod))
            ) {
                this.pod.startDateExpected = value;
            }
            for (const pdr of this.contract.pdrs) {
                if (ContractComponent.pdrIsEditable(pdr) || ContractComponent.pdrIsNew(pdr)) {
                    pdr.startDateExpected = value;
                }
            }
            if (
                this.pdr != null &&
                (ContractComponent.pdrIsEditable(this.pdr) || ContractComponent.pdrIsNew(this.pdr))
            ) {
                this.pdr.startDateExpected = value;
            }
        }
    }

    get technicalDataMinStartDate(): NgbDateStruct {
        switch (this.contract.contract.typeRequestSupply) {
            case TypeRequest.Voltura:
            case TypeRequest.Switch:
            case TypeRequest.Subentro:
            case TypeRequest.Attivazione:
            default:
                return null;
        }
    }

    private lockContract(contractId: number, forceSession: boolean = false): Observable<number> {
        const lockRequest: ICreateLockRequest = {
            lockedEntity: contractId.toString(),
            lockedEntityType: LockedEntityType.Contract,
            forceSession: forceSession
        };
        return this.dataService.lockEntity(lockRequest).pipe(
            catchError(err => {
                if (err instanceof HttpErrorResponse && err.status === 404) {
                    this.toastr.info(
                        `La sessione di lavoro si è conclusa a causa di un aggiornamento dei dati del contratto`,
                        `Attenzione`,
                        { disableTimeOut: true, closeButton: true }
                    );
                }
                throw err;
            })
        );
    }

    private deleteContractLock(lockId: number): void {
        this.dataService
            .deleteLock(lockId)
            .pipe(
                catchError(err => {
                    console.error(err);
                    return EMPTY;
                })
            )
            .subscribe();
    }

    private openLockConflictModal(): void {
        console.debug(`openLockConflictModal`);
        this.closeModal();
        this._openModal(this.templateLockConflict);
    }

    async lockContractForcingSession(id: number) {
        console.debug(`lockContractForcingSession`, this.backupModalMode);
        this.modalService.dismissAll();
        switch (this.backupModalMode) {
            case ModalMode.Delete:
                this._removeContract(
                    this.lockTemplateRef,
                    this.contractEditBackup.contract.id,
                    true
                );
                break;
            case ModalMode.Edit:
                await this._editContract(
                    this.lockTemplateRef,
                    this.contractEditBackup.contract.id,
                    true,
                    true
                );
                break;
            case ModalMode.ChangePhase:
                await this.changeContractPhase(
                    this.lockTemplateRef,
                    this.contractEditBackup.contract.id,
                    true,
                    true
                );
                break;
            case ModalMode.ExportCSV:
            case ModalMode.Info:
            case ModalMode.Create:
                break;
        }
    }

    copyCityFromClientSectionToSignaturePlace() {
        const city = this.clientCity;
        if (city != null) {
            this.contract.contract.signaturePlace = city.fullName;
        }
    }

    contractTypeLabel(contractType: TypeContract) {
        switch (contractType) {
            case TypeContract.Private:
                return 'PRIVATO';
            case TypeContract.Business:
                return 'BUSINESS';
            default:
                return '--';
        }
    }

    get identityDocumentSectionLabel(): string {
        if (this.isPrivateType) {
            return 'DOCUMENTO DI IDENTITA\' DEL CLIENTE';
        } else if (this.isBusinessType) {
            return 'DOCUMENTO DI IDENTITA\' DEL RAPPRESENTANTE LEGALE';
        } else {
            console.warn(`The contract is found not to be private nor business`);
            return 'DOCUMENTO DI IDENTITA\'';
        }
    }

    private async loadSupplyOffer(
        supplyOfferFamily: string,
        energyOrGasContract: EnergyOrGasContract
    ): Promise<void> {
        function toSupplyType(eorg: EnergyOrGasContract): SupplyType {
            switch (eorg) {
                case EnergyOrGasContract.Energy:
                    return SupplyType.Light;
                case EnergyOrGasContract.Gas:
                    return SupplyType.Gas;
                default:
                    console.error(`Cannot convert ${eorg} to SupplyType.`);
                    return null;
            }
        }

        this.supplyOffers = null;

        if (supplyOfferFamily == null) {
            return;
        }

        const supplyType = toSupplyType(energyOrGasContract);
        if (supplyType == null) {
            console.error(`Cannot load supply offers without the supply type.`);
            return;
        }

        this.isLoadingSupplyOffers = true;

        this.supplyOffers = await this.dataService
            .getSupplyOffersByFamilyAndSupplyType(supplyOfferFamily, supplyType)
            .pipe(
                map(response => response.payload.map(s => s.size)),
                catchError(err => {
                    console.error(err);
                    return EMPTY;
                })
            )
            .toPromise();

        this.isLoadingSupplyOffers = false;
    }

    validatePodOffer() {
        if (this.pod != null && this.iAmPataviumOperator) {
            this.pod.supplyOfferResponsible = SessionStorageService.sessionInfo.userId;
        }
    }

    validatePdrOffer() {
        if (this.pdr != null && this.iAmPataviumOperator) {
            this.pdr.supplyOfferResponsible = SessionStorageService.sessionInfo.userId;
        }
    }

    cleanPodOfferValidation() {
        if (this.pod != null && this.iAmPataviumOperator) {
            this.pod.supplyOfferResponsible = null;
        }
    }

    cleanPdrOfferValidation() {
        if (this.pdr != null && this.iAmPataviumOperator) {
            this.pdr.supplyOfferResponsible = null;
        }
    }

    toggleRicercaClientePerCodiceFiscaleOId(): void {
        this.ricercaClientePerCodiceFiscaleOId = !this.ricercaClientePerCodiceFiscaleOId;
    }

    get ricercaClientePerCodiceFiscaleOIdLabel(): string {
        if (this.isBusinessType) {
            return 'Ricerca per partita iva o codice cliente';
        } else if (this.isPrivateType) {
            return 'Ricerca per codice fiscale o codice cliente';
        } else {
            return 'Ricerca per partita iva/codice fiscale o codice cliente';
        }
    }

    private storeSafeUrlForFile(file: IContractAttachment): void {
        this.fileDownloadService
            .getSecureUrlForFile(file.id)
            .pipe(
                tap(safeUrl => this.contractAttachments.setSafeUrl(file, safeUrl)),
                catchError(err => {
                    console.error(
                        `Non è stato possibile ottenere uno url sicuro ` +
                        `per il file ${file.id} (${file.name})`,
                        err
                    );
                    this.toastr.error(
                        `Errore durante la gestione del file ${file.name}: ` +
                        `non sarà possibile accedere al suo contenuto.`
                    );
                    return EMPTY;
                })
            )
            .subscribe();
    }

    private setSafeUrlForAudioFiles(): void {
        const audioFiles: IContractAttachment[] = [].concat(
            this.contractAttachments.registrazione_pre_adesione,
            this.contractAttachments.registrazione_adesione,
            this.contractAttachments.chiamata_verifica,
            this.contractAttachments.vocal_order
        );
        for (const file of audioFiles) {
            if (file.id != null) {
                this.storeSafeUrlForFile(file);
            }
        }
    }

    couldBePdf(attachment: IContractAttachment) {
        try {
            return [
                AttachType.CartaIdentita,
                AttachType.ContrattoCartaceo,
                AttachType.IvaAgevolata,
                AttachType.DatiCatastali,
                AttachType.CodiceFiscale,
                AttachType.Patente,
                AttachType.RichiestaFornitura,
                AttachType.CondizioniEconomiche,
                AttachType.AgevolazioneAccise,
                AttachType.AllegatoGenerico,
                AttachType.FileAudioFirma,
                AttachType.UltimaBolletta,
                AttachType.VisuraCamerale,
                AttachType.Passaporto,
                AttachType.RiconoscimentoGenerico,
                AttachType.CartaIdentitaElettronica,
                AttachType.Delega,
                AttachType.ServizioUltimaIstanza,
                AttachType.LegittimaOccupazione
            ].includes(attachment.type);
        } catch (e) {
            console.error(e);
            return false;
        }
    }

    isAudio(attachment: IContractAttachment): boolean {
        try {
            return [
                AttachType.RegistrazionePreAdesione,
                AttachType.RegistrazioneAdesione,
                AttachType.ChiamataVerifica,
                AttachType.VocalOrder
            ].includes(attachment.type);
        } catch (e) {
            console.error(e);
            return false;
        }
    }

    isRegistrazionePreAdesione(attachment: IContractAttachment): boolean {
        return attachment != null && attachment.type === AttachType.RegistrazionePreAdesione;
    }

    get signatureDatePicker(): TDateTimePicker {
        if (
            this.contractAttachments != null &&
            this.contractAttachments.registrazione_pre_adesione != null &&
            this.contractAttachments.registrazione_pre_adesione.length > 0
        ) {
            return 'date-time';
        }
        return 'date';
    }

    get signatureDateFormat(): TDateTimeFormat {
        if (
            this.contractAttachments != null &&
            this.contractAttachments.registrazione_pre_adesione != null &&
            this.contractAttachments.registrazione_pre_adesione.length > 0
        ) {
            return 'medium';
        }
        return 'mediumDate';
    }

    get isTeleselling(): boolean {
        return (
            this.contractAttachments != null &&
            this.contractAttachments.registrazione_pre_adesione != null &&
            this.contractAttachments.registrazione_pre_adesione.length > 0
        );
    }
    get canInsertSignaturePlace() {
        return this.canInsertSignatureDate;
    }

    get canInsertSignatureDate() {
        const cond1 = this.isVirgin;
        const cond2 = (this.isTeleselling &&
            (this.audioAdesioneContrattualeHasBeenListenedTo || !this.audioAdesioneContrattualeNeedToBeListenedTo) &&
            [PhaseContract.AdesioneConfermata].includes(this.contract.contract.phase));
        // for condition 3 see comments task's P-1-T421 comments and task P-1-T532.
        const cond3 = (this.iAmPataviumOperator || this.iAmAdmin) &&
            [PhaseContract.CheckVocalOrder, PhaseContract.AttesaRestituzionePlico, PhaseContract.AttesaRicevimentoPlicoFirmato].includes(this.contract.contract.phase);
        return cond1 || cond2 || cond3;
    }


    get hasVocalOrderFile() {

        return this.contract.files.findIndex((file) => {

            return file.idAttachType === 25;

        });

    }


    get hasVocalOrderBeenListened() {

        return this.contract.contract.isVocalOrderListened === true || (this.vocalOrdersListened.length !== 0 && this.vocalOrdersListened.findIndex((vorder) => {

            return vorder.contractId === this.contract.contract.id && vorder.listened === true;

        }) !== -1);

    }


    get canChangeVocalOrderPhase() {

        if (this.iAmPataviumOperator || this.iAmAdmin) {

            if (this.hasVocalOrderFile !== -1) { // ha un file di vocal order

                if (this.hasVocalOrderBeenListened) { // è stato ascoltato

                    return true;

                } else { // non è stato ascoltato

                    if (PhaseContract.CheckVocalOrder !== this.contract.contract.phase && PhaseContract.ToConfirmByPatavium !== this.contract.contract.phase) {

                        return true;

                    } else {

                        return false;

                    }

                }


            } else { // non esiste il file

                return true;

            }

        } else {

            return true;

        }

    }


    infoModeAudioForwardEnabled(attachment: IContractAttachment): boolean {
        return attachment.type !== AttachType.RegistrazioneAdesione;
    }

    onAdesioneContrattualeEnded() {
        this.audioAdesioneContrattualeHasBeenListenedTo = true;
    }

    onVocalOrderEnded() {

        const idx = this.vocalOrdersListened.findIndex((vorder) => {

            return vorder.contractId === this.contract.contract.id;

        });


        if (idx === -1) {

            this.vocalOrdersListened.push({

                contractId: this.contract.contract.id,
                listened: true

            })

        }

    }

    isEmpty(list: any[]) {
        return list != null && list.length === 0;
    }

    getEditContractButtonTooltip(contract: TableContractModel): string {
        if (this.tableContractIsEditable(contract)) {
            return 'Aggiorna/Modifica contratto';
        }
        return 'Modifica non più permessa, contratto già trasmesso per la validazione';
    }

    getRemoveContractButtonTooltip(contract: TableContractModel): string {
        if (this.tableContractIsDeletable(contract)) {
            return 'Elimina contratto';
        }
        return 'Eliminazione non permessa, contratto già inviato per la validazione in precedenza';
    }

    tableContractIsEditable(contract: TableContractModel) {
        return (
            contract != null &&
            contract.meta != null &&
            contract.meta.isEditable === true &&
            this.isInitFinished === true
        );
    }

    tableContractIsDeletable(contract: TableContractModel) {
        return (
            contract != null &&
            contract.meta != null &&
            contract.meta.isDeletable === true &&
            this.isInitFinished === true
        );
    }

    private getSieveStringForExport() {
        const ss = new SieveString();
        const fromDateFilter: ISieveFilterObject = {
            key: 'createdDateTime',
            operator: SieveOperator.GoE,
            value: this.getExportStartDateFilter()
        };
        const toDateFilter: ISieveFilterObject = {
            key: 'createdDateTime',
            operator: SieveOperator.LoE,
            value: this.getExportEndDateFilter()
        };
        ss.addFilters([fromDateFilter, toDateFilter]);
        return ss;
    }

    private getExportStartDate(): Date {
        return this.csvStartDate;
    }

    private getExportEndDate(): Date {
        // We add one day to the selected endDate in order to include contracts created in the endDate day
        const endDatePlusOne = new Date(this.csvEndDate.getTime());
        endDatePlusOne.setUTCDate(this.csvEndDate.getDate() + 1);
        return endDatePlusOne;
    }

    private getExportStartDateFilter(): string {
        const exportStartDate = this.getExportStartDate();
        return this.utilsDate.inputDateGetter(exportStartDate);
    }

    private getExportEndDateFilter(): string {
        const exportEndDate = this.getExportEndDate();
        return this.utilsDate.inputDateGetter(exportEndDate);
    }

    private getCsvFileForSimpleExport(): void {
        this.isWaitingExport = true;
        const ss = this.getSieveStringForExport();
        this.contractService
            .countExportableContractsForSimpleExport(ss)
            .pipe(
                switchMap(response => {
                    /* If there are no contracts to export, inform the user and DO NOT CLOSE THE MODAL*/
                    if (response.item.count === 0) {
                        this.toastr.info(
                            "Nessun contratto da esportare nell'intervallo di date selezionato"
                        );
                        // nothing to wait for
                        this.isWaitingExport = false;
                        return NEVER; // 'NEVER' prevent from the execution of the 'finally' block
                    }
                    /* If contracts don't exceed the number limit to be downloaded download them,
                    otherwise enqueue an async task. In this case contracts will be sent by e-mail*/
                    if (response.item.canBeDownload) {
                        return this.downloadCsvFileOfSimpleExport(ss);
                    } else {
                        this.exportToBeSend = true;
                        const startDate: Date = this.getExportStartDate();
                        const endDate: Date = this.getExportEndDate();
                        return this.enqueueTaskOfSimpleExport(startDate, endDate).pipe(
                            delay(this.exportTaskDelay)
                        );
                    }
                }),
                catchError(err => {
                    console.error(err);
                    this.toastr.error(`Errore durante il tentativo di export`);
                    return EMPTY;
                }),
                finalize(() => {
                    this.isWaitingExport = false;
                    this.closeModal();
                    this.exportToBeSend = false;
                })
            )
            .subscribe();
    }

    private getCsvFileForSpecificExport(exportType: EnergyOrGasContract): void {
        this.exportToBeSend = true;
        this.isWaitingExport = true;
        const taskSettings = new TaskExportRequestSettings();
        taskSettings.energyOrGas = exportType;
        const fromDate = this.getExportStartDate();
        const toDate = this.getExportEndDate();
        const typeExport = TypeExportContract.LikeOperator;
        this.enqueueExportTask(typeExport, fromDate, toDate, exportType)
            .pipe(
                delay(this.exportTaskDelay),
                map(() => {
                    this.toastr.success('Export avviato con successo');
                }),
                catchError(err => {
                    console.error(err);
                    this.toastr.error(`Errore durante il tentativo di export`);
                    return EMPTY;
                }),
                finalize(() => {
                    this.isWaitingExport = false;
                    this.closeModal();
                    this.exportToBeSend = false;
                })
            )
            .subscribe();
    }

    private downloadCsvFileOfSimpleExport(ss: SieveString): Observable<void> {
        return this.contractService.exportContractCSV(ss).pipe(
            map(streamedFile => {
                const name = streamedFile.name;
                const buffer = streamedFile.buffer;
                const mimeType = streamedFile.mimeType;
                return this.fileDownloadService.download(buffer, mimeType, name);
            }),
            catchError(err => {
                // L'errore è volontariamente rilanciato per permettere che venga gestito dove serve
                throw err;
            })
        );
    }

    private enqueueTaskOfSimpleExport(startDate: Date, endDate: Date): Observable<void> {
        const typeExport = TypeExportContract.LikeAgency;
        return this.enqueueExportTask(typeExport, startDate, endDate).pipe(
            map(() => {
                this.toastr.success('Export avviato con successo');
            }),
            catchError(err => {
                // L'errore è volontariamente rilanciato per permettere che venga gestito dove serve
                throw err;
            })
        );
    }
    private enqueueTaskOfPhoneCallExport(startDate: Date, endDate: Date): Observable<void> {
        const typeExport = TypeExportContract.PhoneCall;
        return this.enqueueExportTask(typeExport, startDate, endDate).pipe(
            map(() => {
                this.toastr.success('Export avviato con successo');
            }),
            catchError(err => {
                // L'errore è volontariamente rilanciato per permettere che venga gestito dove serve
                throw err;
            })
        );
    }

    private enqueueExportTask(
        typeExport: TypeExportContract,
        fromDate: Date,
        toDate: Date,
        energyOrGas: EnergyOrGasContract = null
    ): Observable<IPataviumPagedResponse<ITaskExportResponse>> {
        if (fromDate == null || toDate == null || typeExport === null) {
            console.error(`Cannot enqueue a task without the required infos`);
            return;
        }
        const taskSimpleSettings = new TaskExportRequestSettings();
        taskSimpleSettings.fromDate = fromDate;
        taskSimpleSettings.toDate = toDate;
        taskSimpleSettings.energyOrGas = energyOrGas;
        taskSimpleSettings.typeExport = typeExport;
        return this.contractService.enqueueExportTask(taskSimpleSettings);
    }

    get businessFiscalCodeLabel(): string {
        if (this.isClientAGenericCompany) {
            return 'PARTITA IVA';
        } else if (this.isClientAnAssociazioneOrCondominio) {
            return 'CODICE FISCALE';
        } else {
            return '--';
        }
    }

    get businessFiscalCodePlaceholder(): string {
        if (this.isClientAGenericCompany) {
            return 'Partita iva';
        } else if (this.isClientAnAssociazioneOrCondominio) {
            return 'Codice fiscale';
        } else {
            return '--';
        }
    }

    get patternToRespectForBusinessFiscalCode(): string {
        if (this.isClientAGenericCompany) {
            return RespectPatternDirective.pivaPattern.name;
        } else if (this.isClientAnAssociazioneOrCondominio) {
            return RespectPatternDirective.fiscalCodePattern.name;
        }
    }

    loadPreAdesioneAttachment(inputPreAdesione: HTMLInputElement) {
        if (inputPreAdesione.disabled) {
            return;
        }

        this.closeFileAndDateTemplate();

        const modalOptions: NgbModalOptions = {
            centered: true,
            size: 'lg',
            windowClass: 'modal-xxl',
            backdrop: 'static',
            keyboard: false
        };
        this.fileAndDateTemplateModalRef = this.openTemplateRef(this.fileAndDateTemplate, modalOptions);

        this.fileAndDateTemplateModalRef
            .result
            .then(async (value: IFileAndDate) => {
                console.log('Attempt to load file and date');
                if (value != null && value.file != null && value.date != null) {
                    try {
                        const att = new Attachment({
                            id: null,
                            label: null,
                            loading: true,
                            name: value.file.name,
                            type: AttachType.RegistrazionePreAdesione,
                            safeUrl: null,
                            uploadDateTime: null,
                            uuid: null,
                            chiamataPreAdesioneDateTime: value.date
                        });
                        const timestampInfos = new TimestampInfos({ chiamataPreAdesioneDateTime: value.date });
                        await this._uploadContractAttachment(att, value.file, null, this.him.id, timestampInfos, true);
                    } catch (e) {
                        console.error(e);
                        this.toastr.error('Impossibile caricare il file');
                    }
                } else {
                    this.toastr.error(`Sono necessari sia la registrazione di pre-vendita che la data della chiamata di pre-vendita`);
                }
            })
            .catch(err => {
                if (err === ModalDismissReason.Exit) {
                    console.log('Successfully closing modal');
                    return;
                }
                console.error(err);
                this.toastr.error('Impossibile caricare il file');
            });
    }

    closeFileAndDateTemplate() {
        this.exitModal(this.fileAndDateTemplateModalRef);
    }

    submitFileAndDateTemplate(file: File, date: Date) {
        if (file == null || date === null) {
            this.toastr.error(`Sono necessari sia la registrazione di pre-vendita che la data della chiamata di pre-vendita`);
            return;
        }
        if (this.fileAndDateTemplateModalRef) {
            const result: IFileAndDate = { file: file, date: date };
            this.fileAndDateTemplateModalRef.close(result);
        }
    }

    private async _uploadContractAttachment(attachment: Attachment, file: File, description: string, idOwner: number, timestampInfos: ITimestampInfos, timestamped: boolean) {
        this.contractAttachments.pushAttachment(attachment);
        await this.dataService
            .uploadDocument(file, description, idOwner, timestampInfos, timestamped)
            .pipe(
                tap(response => {
                    const _file = response.item;
                    // not loading  anymore
                    this.contractAttachments.setLoading(attachment, false);
                    //set id in case of unlinking
                    this.contractAttachments.setId(attachment, _file.id);
                    this.contractAttachments.setUploadedDateTime(attachment, _file.uploadDateTime);
                    //add file to contract.files avoiding duplicates
                    // and set idAttachType to attachType
                    const index = this.contract.files.findIndex(
                        f => f.idFile === _file.id
                    );
                    if (index === -1) {
                        const fileWithAttachReq = new FileWithAttachRequest({
                            idFile: _file.id,
                            idAttachType: attachment.type,
                            chiamataPreAdesioneDateTime: attachment.chiamataPreAdesioneDateTime
                        });

                        this.contract.files.push(fileWithAttachReq);
                    }
                    if (attachment.type === AttachType.RegistrazionePreAdesione) {
                        this.storeSafeUrlForFile(attachment);
                    }
                }),
                catchError(err => {
                    this.contractAttachments.removeAttachment(attachment);
                    this.toastr.error('Errore durante il caricamento del file');
                    console.error(err);
                    return EMPTY;
                })
            )
            .subscribe();
    }

    private getCsvFileForPhoneCallExport(): void {
        this.isWaitingExport = true;
        const ss = this.getSieveStringForExport();
        this.contractService
            .countExportableContractsForPhoneCallExport(ss)
            .pipe(
                switchMap(response => {
                    /* If there are no contracts to export, inform the user and DO NOT CLOSE THE MODAL*/
                    if (response.item.count === 0) {
                        this.toastr.info(
                            "Nessun contratto da esportare nell'intervallo di date selezionato"
                        );
                        // nothing to wait for
                        this.isWaitingExport = false;
                        return NEVER; // 'NEVER' prevent from the execution of the 'finally' block
                    }
                    /* If contracts don't exceed the number limit to be downloaded download them,
                    otherwise enqueue an async task. In this case contracts will be sent by e-mail*/
                    if (response.item.canBeDownload) {
                        return this.downloadCsvFileOfPhoneCallExport(ss);
                    } else {
                        this.exportToBeSend = true;
                        const startDate: Date = this.getExportStartDate();
                        const endDate: Date = this.getExportEndDate();
                        return this.enqueueTaskOfPhoneCallExport(startDate, endDate).pipe(
                            delay(this.exportTaskDelay)
                        );
                    }
                }),
                catchError(err => {
                    console.error(err);
                    this.toastr.error(`Errore durante il tentativo di export`);
                    return EMPTY;
                }),
                finalize(() => {
                    this.isWaitingExport = false;
                    this.closeModal();
                    this.exportToBeSend = false;
                })
            )
            .subscribe();
    }

    private downloadCsvFileOfPhoneCallExport(ss: SieveString): Observable<void> {
        return this.contractService.getPhoneCallExportCSV(ss).pipe(
            map(streamedFile => {
                const name = streamedFile.name;
                const buffer = streamedFile.buffer;
                const mimeType = streamedFile.mimeType;
                return this.fileDownloadService.download(buffer, mimeType, name);
            }),
            catchError(err => {
                // L'errore è volontariamente rilanciato per permettere che venga gestito dove serve
                throw err;
            })
        );
    }

    confirmAttachTypes() {
        if (this.contractAttachments.non_mappati.some(a => a.tmpType == null)) {
            this.toastr.info('Selezionare il tipo per ciascuno degli allegati');
            return;
        }
        this.doConfirmAttachTypeModal();
    }

    closeConfirmAttachTypeTemplate() {
        this.exitModal(this.confirmAttachTypeTemplateModalRef);
    }

    exitModal(ref: NgbModalRef): void {
        if (ref) {
            ref.dismiss(ModalDismissReason.Exit);
        }
    }

    doConfirmAttachTypeModal() {
        this.closeConfirmAttachTypeTemplate();

        const modalOptions: NgbModalOptions = {
            centered: true,
            size: 'lg',
            windowClass: 'modal-xxl',
            backdrop: 'static',
            keyboard: false
        };
        this.confirmAttachTypeTemplateModalRef = this.openTemplateRef(this.confirmAttachTypeTemplate, modalOptions);

        this.confirmAttachTypeTemplateModalRef
            .result
            .then(async () => {
                // confirm attach type
                const lst = this.contractAttachments.non_mappati.slice();
                for (const notMappedAtt of lst) {
                    this.confirmAttachType(notMappedAtt);
                }
                //change contractPhase
                this.contract.contract.phase = PhaseContract.VadPreValidazioneBackoffice;
                await this.contractService.createOrUpdateContractForTable(this.contract)
                    .pipe(
                        tap(() => this.toastr.success('Contratto aggiornato con successo')),
                        catchError(err => {
                            console.error('Error trying to save contract', err);
                            this.toastr.error('Si è verificato un errore durante il salvataggio del contratto');
                            return EMPTY;
                        }),
                        finalize(() => this.closeModal())
                    ).toPromise();
            })
            .catch(err => {
                if (err === ModalDismissReason.Exit) {
                    console.log('Successfully closing modal');
                    return;
                }
                console.error(err);
                this.toastr.error('Impossibile confermare il tipo dei file');
            });
    }

    submitConfirmAttachTypeTemplate() {
        if (this.confirmAttachTypeTemplateModalRef) {
            this.confirmAttachTypeTemplateModalRef.close();
        }
    }


    confirmAttachType(attachment: IContractAttachmentNotMapped) {
        const index = this.contract.files.findIndex(f => f.idFile === attachment.id);
        if (index === -1) {
            console.error(`File with idFile=${attachment.id} not found for contract ${this.contract.contract.id}`);
            this.toastr.error('File non trovato');
            return;
        }
        const type = attachment.tmpType;
        this.contract.files[index].idAttachType = type;
        this.contractAttachments.setAttachType(attachment, type);
    }

    get confirmAttachTypeText(): string {
        let txt = `Con la presente, io sottoscritto ${this.sessionInfo.fullName},`;
        if (this.sessionInfo.cf) {
            txt += `codice fiscale ${this.sessionInfo.cf},`;
        }

        txt += `certifico di aver verificato l'identità del Sig. ${this.contract.client.lastName} ${this.contract.client.firstName}
            di cui io sono certo, confermando la sottoscrizione della proposta ricevuta.`;

        return txt;
    }


    get notesOnPhaseChangeModalAreEditable(): boolean {
        if (this.iAmSpecializedOperator) {
            return false;
        }
        if (this.iAmPataviumOperator) {
            return this.thereAreSomeAvailablePhases;
        }
        return false;
    }

    private getSavedContractMessage(phase: PhaseContract, modalMode: ModalMode) {
        let message = 'Contratto salvato con successo'; // default
        if (phase === PhaseContract.Draft) {
            message = 'Contratto salvato come bozza ';
        } else {
            switch (this.modalMode) {
                case ModalMode.Create:
                    message = 'Contratto creato con successo';
                    break;
                case ModalMode.Edit:
                case ModalMode.ChangePhase:
                    message = 'Contratto aggiornato con successo';
                    break;
            }
        }
        return message;
    }

    get isANewTechnicalData() {
        return this.tecnicalDataIndex == null;
    }

    async saveNewContractPhase() {

        console.log("*********************")

        if (this.phaseToChangeTo == null) {
            this.toastr.warning(`È necessario selezionare una fase`);
            return;
        }

        if (!this.canChangeVocalOrderPhase) {
            this.toastr.warning(`Il file di Vocal Order deve essere presente ed essere stato ascoltato.`);
            return;
        }

        this.contract.contract.phase = this.phaseToChangeTo;

        // pass the vocal order listened setttings to contract saving
        if (this.hasVocalOrderFile !== -1 && this.hasVocalOrderBeenListened) {

            this.contract.contract.isVocalOrderListened = true;

        } else {

            this.contract.contract.isVocalOrderListened = false;

        }

        if (this.needToSendSmsForAdesioneADistanza || this.needToSendSmsForAttesaVocalOrder || this.needToSendSmsForChiamataDiBenvenuto) {

            this.saveAndSendSmsForContract();

        } else {

            this.saveContract();

        }

    }


    saveAndSendSmsForContract(): void {
        this.isSavingContract = true;

        // set notes
        this.setContractNotes();

        this.contractService.sendSmsForContract(this.contract)
            .pipe(
                tap(resp => {
                    console.debug(resp);
                    if (!resp.toBeSent) {
                        this.toastr.warning(`L'sms non è stato inviato in quanto non necessario o perché mancano dei dati essenziali all'invio.`);
                    } else {
                        this.toastr.success(`Contratto salvato ed sms inviato con successo`);
                    }
                    this.closeModal();
                    this.initData();
                }),
                catchError(err => {
                    console.error(err);
                    this.toastr.error(`Errore durante il salvataggio del contratto o durante l'invio dell'sms.`,
                        `Attenzione`,
                        { closeButton: true, disableTimeOut: true });
                    return EMPTY;
                }),
                finalize(() => this.isSavingContract = false))
            .subscribe();
    }

    askForConfirmation(type: 'adesioneADistanza' | 'normalParcel' | 'sendParcelToEsign'): void {
        console.debug(`Ask for confirmation: type is '${type}'`);
        let text = null;
        let newAdesioneADistanza: boolean = null;
        if (type === 'adesioneADistanza') {
            text = `Confermi l'invio del plico con il processo di adesione a distanza? ` +
                `Il cliente dovrà aderire tramite chiamata registrata se privato o PEC se business. ` +
                `Una volta scelta questa funzione, non sarà possibile scegliere l'invio standard.`;
            newAdesioneADistanza = true;
        } else if (type === 'normalParcel') {
            text = `Confermi l'invio del plico con il processo standard? ` +
                `Per procedere all'attivazione, dovrà essere allegata alla Piattaforma ` +
                `il contratto originale scansionato. `;
            newAdesioneADistanza = false;
        } else if (type === 'sendParcelToEsign') {
            text = `Confermi l'invio del plico al cliente per la firma digitale? ` +
                `Il cliente riceverà una email contenente il plico contrattuale e un link allo ` +
                'strumento di firma. Verificare la correttezza di email e numero di telefono mobile ' +
                'del cliente.';
            newAdesioneADistanza = false;
        } else {
            console.error(`Unhandled confirmation type '${type}'`);
            this.toastr.error(`Impossibile chiedere conferma dell'azione. Azione sconosciuta.`);
            return;
        }
        this.askForConfirmationRef = this.modalService.open(AskForConfirmationComponent);
        const getComponent = () => this.askForConfirmationRef.componentInstance as AskForConfirmationComponent;
        getComponent().title = 'Attenzione';
        getComponent().text = text;


        this.askForConfirmationRef.result
            .then(resp => {
                console.debug(`Ask for confirmation: response is '${resp}'`);
                if (resp === true) {
                    if (type === 'sendParcelToEsign') {
                        this.sendParcelToEsign();
                    } else if (type === 'adesioneADistanza' || type === 'normalParcel') {
                        this.sendParcel(newAdesioneADistanza);
                    } else {
                        console.error(`Unhandled confirmation type '${type}'`);
                        this.toastr.error(`Impossibile confermare la richiesta. Azione non gestita.`);
                        return;
                    }
                } else {
                    if (type === 'adesioneADistanza' || type === 'normalParcel' || type === 'sendParcelToEsign') {
                        console.debug(`Nothing to do`);
                    } else {
                        console.error(`Unhandled confirmation type '${type}'`);
                        this.toastr.error(`Impossibile annullare la richiesta. Azione non gestita.`);
                        return;
                    }
                }
            })
            .catch(err => {
                console.error(`Error asking for confirmation`, err);
                this.toastr.error(`Si è verificato un errore. Risposta non riconosciuta.`);
            });

    }


    get delegaIsValid(): boolean {
        if (this.contract == null ||
            this.contract.contract == null) {
            return true;
        }
        return (this.contract.contract.delegaName != null &&
            this.contract.contract.delegaLastname != null &&
            this.contract.contract.delegaCf != null &&
            this.contractAttachments.delega.length > 0)
            ||
            (this.contract.contract.delegaName == null &&
                this.contract.contract.delegaLastname == null &&
                this.contract.contract.delegaCf == null &&
                this.contractAttachments.delega.length === 0);
    }

    insertDelega(): void {
        this.hasDelega = true;
    }

    removeDelega(): void {
        this.hasDelega = false;
        this.contract.contract.delegaName = null;
        this.contract.contract.delegaLastname = null;
        this.contract.contract.delegaCf = null;
        this.contractAttachments.delega.forEach(att => {
            this.unLinkDocument(att);
        });
    }

    toggleDelega(): void {
        this.hasDelega ? this.removeDelega() : this.insertDelega();
    }

    getTypeRequestSupplyLabel(requestType: TypeRequest) {
        switch (requestType) {
            case TypeRequest.Switch:
                return 'SWITCH';
            case TypeRequest.Voltura:
                return 'VOLTURA';
            case TypeRequest.Attivazione:
                return 'ATTIVAZIONE';
            case TypeRequest.Subentro:
                return 'SUBENTRO';
            case TypeRequest.CambioPiano:
                return 'CAMBIO PIANO';
            case TypeRequest.VolturaConAttivazione:
                return 'VOLTURA CON ATTIVAZIONE';
            case TypeRequest.None:
            default:
                return '--';
        }
    }


    toggleSearchBox(prop: string) {

        if (this.searchprop === null) {

            this.searchprop = prop;

        } else {

            this.searchprop = null;
            this.searchval = null;

        }

    }

    onSearchboxCloseEvent(event) {

        this.searchprop = null;
        this.searchval = null;

    }


    forcePreScreening() {

        this.prescreeningLoader = true;

        this.contractService
            .customerAudit({ contractId: this.contract.contract.id, agentId: this.contract.idAgent })
            .pipe(
                map(async response => {

                    if (response.item.status !== 400) {

                        if (response.item.acceptable === true) {

                            this.contract.contract.isPreScreeningOk = true;

                        } else {

                            this.contract.contract.isPreScreeningOk = false;

                        }
                        this.contract.contract.isPreScreeningError = false;

                    } else {


                        this.contract.contract.isPreScreeningOk = false;
                        this.contract.contract.isPreScreeningError = true;

                    }

                    this.toastr.info('PreScreening completato');
                    this.prescreeningLoader = false;
                    const successResponse: IRrs<ICustomerAuditRequest, ICustomerAuditResponse> = {
                        request: { contractId: this.contract.contract.id, agentId: this.contract.idAgent },
                        response: response.item,
                        success: false
                    };
                    return of(successResponse);

                }),
                catchError((err: HttpErrorResponse) => {
                    this.toastr.error('Servizio di Pre-Screening non attivo');
                    this.prescreeningLoader = false;
                    this.contract.contract.note = this.noteOriginali;
                    const failureResponse: IRrs<ICustomerAuditRequest, ICustomerAuditResponse> = {
                        request: { contractId: this.contract.client.id, agentId: this.contract.idAgent },
                        response: null,
                        success: false
                    };
                    return of(failureResponse);
                }),
                finalize(() => { })
            )
            .subscribe();
    }


    async associatePortaUnAmico(id, idp) { // id = id referral, idp = id portato

        try {

            // CHECK PORTANTE
            this.dataService.checkByTaxCode(id).subscribe(portanteResponse => {

                // PORTANTE NON ABILITATO
                if (portanteResponse.status === 404) {

                    // UPSERT AGGIUNGO PORTANTE
                    this.dataService.addPortaUnAmico(id, this.sessionInfo.userId).subscribe(addPortanteResponse => {

                        if (addPortanteResponse && addPortanteResponse.status === 200 || addPortanteResponse.status === 201) {

                            // VERIFICO SE PORTATO E' ABILITATO ALTRIMENTI LO ABILITO
                            this.dataService.checkByTaxCode(idp).subscribe(portatoResponse => {

                                // PORTATO NON ABILITATO LO ABILITO E LO ASSOCIO
                                if (portatoResponse && portatoResponse.status === 404) {

                                    this.dataService.associatePortaUnAmico(Number(idp), this.sessionInfo.userId, Number(addPortanteResponse.id)).subscribe(finalResponse => {

                                        if (!finalResponse || finalResponse.status !== 200) {

                                            this.toastr.error(`Errore durante l\'associazione dell\'opzione PORTAUNAMICO`, 'Errore');

                                            return false;

                                        }

                                    });

                                    // PORTATO ABILITATO LO ASSOCIO
                                } else {

                                    this.dataService.associatePortaUnAmico(Number(idp), this.sessionInfo.userId, Number(addPortanteResponse.id)).subscribe(finalResponse => {

                                        if (!finalResponse || finalResponse.status !== 200) {

                                            this.toastr.error(`Errore durante l\'associazione dell\'opzione PORTAUNAMICO`, 'Errore');

                                            return false;

                                        }

                                    });

                                }

                            });

                        } else {

                            this.toastr.error(`Errore durante l\'associazione dell\'opzione PORTAUNAMICO`, 'Errore');

                            return false;

                        }

                    });

                    // PORTANTE ABILITATO
                } else {

                    // VERIFICO SE PORTATO E' ABILITATO ALTRIMENTI LO ABILITO
                    this.dataService.checkByTaxCode(idp).subscribe(portatoResponse => {

                        // PORTATO NON ABILITATO LO ABILITO E LO ASSOCIO
                        if (portatoResponse && portatoResponse.status === 404) {

                            this.dataService.associatePortaUnAmico(Number(idp), this.sessionInfo.userId, Number(portanteResponse.id)).subscribe(finalResponse => {

                                if (!finalResponse || finalResponse.status !== 200) {

                                    this.toastr.error(`Errore durante l\'associazione dell\'opzione PORTAUNAMICO`, 'Errore');

                                    return false;

                                }

                            });

                            // PORTATO ABILITATO LO ASSOCIO
                        } else {

                            this.dataService.associatePortaUnAmico(Number(idp), this.sessionInfo.userId, Number(portanteResponse.id)).subscribe(finalResponse => {

                                if (!finalResponse || finalResponse.status !== 200) {

                                    this.toastr.error(`Errore durante l\'associazione dell\'opzione PORTAUNAMICO`, 'Errore');

                                    return false;

                                }

                            });

                        }

                    });

                }

            });

        } catch (e) {

            this.toastr.error("Errore durante l\'operazione", "Errore");

        }

    }

}




// WEBPACK FOOTER //
// ./src/app/pages/common/contract/contract.component.ts